<template>
  <div class="order-details--container">
    <LoadingSpinner v-if="isLoading" />
    <Alerts />

    <!-- CUSTOMS MODAL -->
    <b-modal ref="customsModal" size="xl" centered laze no-close-on-esc hide-header-close no-close-on-backdrop
      :visible="showCustomsModal" no-fade :title="err_msg" :hide-header="!verifyCustomForm"
      :header-class="[{ 'bg-danger': verifyCustomForm }]">
      <b-form-row>
        <b-col>
          <b-form-group>
            <b-select v-model="customs.content_type" @change="{ }" :options="[
              { value: 'MERCHANDISE', text: 'Merchandise' },
              { value: 'DOCUMENTS', text: 'Documents' },
              { value: 'GIFT', text: 'Gift' },
            ]" :class="['form-control', 'custom-dropdown', { 'is-invalid': !customs.content_type }]"
              name="customsContentType">
              <template slot="first">
                <option :value="null" disabled>Package Content Type</option>
              </template>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-input style="width: 75px" :class="['form-control', { 'is-invalid': !customs.sender_signature }]"
            v-model="customs.sender_signature" type="text" name="senderSignature" placeholder="Full Legal Name">
          </b-input>
        </b-col>
        <b-col cols="6"></b-col>
      </b-form-row>
      <br />
      <b-form-row v-for="(line, i) in lines" :key="i" class="line">
        <b-col cols='1'>
          <b-input v-model="lines[i].quantity" :class="['form-control', { 'is-invalid': !lines[i].quantity }]"
            type="number" placeholder="Qty" :name="`quantity${i}`"></b-input>
        </b-col>
        <b-col cols='3'>
          <b-input :class="['form-control', { 'is-invalid': !lines[i].description }]" v-model="lines[i].description"
            placeholder="Description (max 50 characters)" maxlength="50" :name="`description${i}`"></b-input>
        </b-col>
        <b-col cols='2'>
          <b-input style="padding-right: 0" :class="['form-control', { 'is-invalid': !lines[i].value }]" v-model="lines[i].value" type="number"
            placeholder="Value($)" :name="`value${i}`" @input="onCustomValueChange"></b-input>
        </b-col>
        <b-col cols='1'>
          <b-form-group append="lb">
            <b-input :class="['form-control', { 'is-invalid': !lines[i].weight1 && !lines[i].weight2 }]" type="number"
              v-model="lines[i].weight1" placeholder="0(lb)" :name="`weight${i}`" @input="onCustomWeightChange">
            </b-input>
          </b-form-group>
        </b-col>
        <b-col cols='1'>
          <b-form-group append="oz">
            <b-input :class="['form-control', { 'is-invalid': !lines[i].weight1 && !lines[i].weight2 }]" type="number"
              v-model="lines[i].weight2" placeholder="0(oz)" :name="`weight${i}`" @input="onCustomWeightChange">
            </b-input>
          </b-form-group>
        </b-col>
        <b-col cols='2'>
          <b-input :class="['form-control', { 'is-invalid': isDeliveryEU && !lines[i].tariff }]" v-model="lines[i].tariff" placeholder="HS Tariff #"
            :name="`tariff${i}`"></b-input>
        </b-col>
        <b-col cols='2'>
          <b-form-group>
            <b-form-select style="padding-right: 10px" id="customsOrigin" :class="['form-control', { 'is-invalid': isDeliveryEU && !lines[i].origin }]" v-model="lines[i].origin" :options="countrySelectOptions"
              :name="`origin${i}`" />
              <!-- :selected="!lines[i].origin ? null : lines[i].origin" :name="`origin${i}`" /> -->
          </b-form-group>
        </b-col>
      </b-form-row>
      <div>
        <ul style="margin-left: 5px" class="no-bullets">
          <li>USPS New Customs Requirements for European Union Countries <a target="_blank" href="https://www.usps.com/international/new-eu-customs-rules.htm">https://www.usps.com/international/new-eu-customs-rules.htm  </a>
          <div class="hover-text"><i id="second_info" style="color: darkblue; margin-left: 5px" class="fa-solid fa-circle-info"></i>
            <span class="tooltip-text" id="down">
              <table style="width:100%">
                <tr>
                  <td>Austria</td>
                  <td>Belgium</td>
                  <td>Bulgaria</td>
                  <td>Croatia</td>
                </tr>
                <tr>
                  <td>Republic of Cyprus</td>
                  <td>Czech Republic</td>
                  <td>Denmark</td>
                  <td>Estonia</td>
                </tr>
                <tr>
                  <td>Finland</td>
                  <td>France</td>
                  <td>Germany</td>
                  <td>Greece</td>
                </tr>
                <tr>
                  <td>Hungary</td>
                  <td>Ireland</td>
                  <td>Italy</td>
                  <td>Latvia</td>
                </tr>
                <tr>
                  <td>Lithuania</td>
                  <td>Luxembourg</td>
                  <td>Malta</td>
                  <td>Netherlands</td>
                </tr>
                <tr>
                  <td>Norway</td>
                  <td>Poland</td>
                  <td>Portugal</td>
                  <td>Romania</td>
                </tr>
                <tr>
                  <td>Slovakia</td>
                  <td>Slovenia</td>
                  <td>Spain</td>
                  <td>Sweden</td>
                </tr>
                <tr>
                  <td>Switzerland</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </span>
          </div>
          </li>
          <li>Finding HS Tariff # by using <a target="_blank" href="https://uscensus.prod.3ceonline.com">US Census Bureau Schedule B Search</a>
          <div class="hover-text"><i id="second_info" style="color: darkblue; margin-left: 5px" class="fa-solid fa-circle-info"></i>
            <span class="tooltip-text" id="top">
              Here’s what an HS number looks like:<br><br>
              You will need a minimum of <b><u>six digits;</u></b> for example: <b>621142</b><br>
              <b>•First two numbers:</b> They represent the category of the product, like textiles or electronics.<br>
              <b>•Middle two numbers:</b> This combination stands for the subcategory of the product, like shirts or shoes.<br>
              <b>•Last two numbers:</b> They represent the material of the product, like leather.<br><br>
              It’s important to understand that these codes aren’t unique to each product. For instance, the code 950450 covers video game consoles, table and parlor games, and automatic bowling equipment.
            </span>
          </div>
          </li>
          <li>Understanding Harmonized System Codes (HS Tariff #) <a target="_blank" href="https://www.trade.gov/harmonized-system-hs-codes">https://www.trade.gov/harmonized-system-hs-codes</a></li>
        </ul>
      </div>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn variant="danger" :disabled="!(lines.length > 1)" @click="deleteLastLine()">Delete last Item</b-btn>
        <b-btn variant="primary" @click="addLine">Add additional Item</b-btn>
        <b-btn variant="success" @click="onHideCustomsModal" :disabled="verifyCustomForm">Save and Close</b-btn>
      </div>
    </b-modal>
    <!-- CUSTOMS MODAL -->

    <form ref="newShipmentForm" @submit.prevent="getRate">
      <b-alert show v-if="error_msg" variant="danger" class="position-affix">
        <i class="fa fa-exclamation-triangle fa-xl mr-2" aria-hidden="true"></i>{{ error_msg }}
      </b-alert>
      <div class="row">
        <!-- COLUMN 1 -->
        <div class="col-md-6">
          <!-- ORIGIN DETAILS -->
          <!-- <div class="card">
              <div class="card-header blue">
                Origin Address
                <span v-show="employee_name" class="float-right text-warning">{{ employee_name }}</span>
              </div>
              <div class="card-body">
                <b-form-row >
                  <b-col >
                    <b-form-group >
                      <b-select
                        v-model="selected"
                        ref="originDropDown"
                        :class="['form-control', 'form-control-sm', 'custom-dropdown', {'is-invalid': !selected}]"
                        :disabled="!shipper_addresses.length"
                        :options="shipper_addresses"
                        @change="onTouched"
                      >
                      </b-select>
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </div>
            </div> -->
          <!-- RECIPIENT INFO -->
          <div class="card">
            <div class="card-header blue">
              Origin Address and Recipient Info
              <span v-show="employee_name" class="float-right text-warning">{{ employee_name }}</span>
            </div>
            <div class="card-body">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <origin-select ref="originDropDown" v-model="selected" :options="shipper_addresses"
                      :selected="selectedOrigin" @change="changedOrigin"></origin-select>
                    <!-- <b-select
                        v-model="selected"
                        ref="originDropDown"
                        :class="['form-control', 'form-control-sm', 'custom-dropdown', !selected ? 'is-invalid': 'origin-selected']"
                        :disabled="!shipper_addresses.length"
                        @change="changedOrigin"
                        :options="shipper_addresses"
                      >
                      </b-select> -->
                  </b-form-group>
                </b-col>
              </b-form-row>
              <hr style="margin: 4px -10px 8px; border-top: 3px solid #2a2a6c" />
              <b-form-group>
                <recipient-select ref="recipientSelect" v-model="selectedRecipient" @change="onChangeRecipient"
                  @clear="onClearRecipient"></recipient-select>
              </b-form-group>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="text" class="form-control" placeholder="Order Number" v-model="order.order_number"
                      maxlength="25" @input="onTouched(false)" @keypress="isNumber($event)"></b-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="text" class="form-control" placeholder="Reference ID" v-model="order.ref_id"
                      maxlength="25" @input="onTouched(false)"></b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="text"
                      :class="['form-control', { 'is-invalid': dirty && !(toAddress.company || toAddress.first_name || toAddress.last_name) }]"
                      placeholder="Company" v-model="toAddress.company" @input="onTouched()" @change="onChanged">
                    </b-input>
                  </b-form-group>
                </b-col>
                <b-col class="paste-address">
                  <b-btn class="w-100 default btn-grey-outline no-hover" @click="showAddressModal">
                    <img src="/images/icons/paste-button.png">
                    <span>
                      Click here to paste address
                    </span>
                  </b-btn>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="text"
                      :class="['form-control', { 'is-invalid': dirty && !(toAddress.company || toAddress.first_name || toAddress.last_name) || isFullNameRequired }]"
                      placeholder="First Name" v-model="toAddress.first_name" name="toFirstName" @input="onTouched()"
                      @change="onChanged"></b-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="text"
                      :class="['form-control', { 'is-invalid': dirty && !(toAddress.company || toAddress.first_name || toAddress.last_name) || isFullNameRequired }]"
                      placeholder="Last Name" v-model="toAddress.last_name" name="toLastName" @input="onTouched()"
                      @change="onChanged"></b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group class="position-relative">
                    <i v-show="dirty && !isAddressValid" id="tooltip-target-1"
                      class="fa fa-exclamation-circle address-help" aria-hidden="true"></i>
                    <b-tooltip custom-class="text-left" placement="left" target="tooltip-target-1" triggers="hover">
                      Address Line 1 requires a number
                    </b-tooltip>
                    <GoogleAutoComplete
                      :g-class="['form-control', { 'is-invalid': dirty && !toAddress.address || dirty && !isAddressValid }]"
                      v-model="toAddress.address" :country="country" @change="onGoogleAddressChange">
                    </GoogleAutoComplete>
                    <!-- <b-input
                        type="text"
                        ref="gAddress"
                        :class="['form-control', {'is-invalid': dirty && !toAddress.address}]"
                        placeholder="Address Line 1"
                        v-model="toAddress.address"
                        name="toAddress"
                        @input="onTouched"
                      ></b-input> -->
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="text" class="form-control" placeholder="Address Line 2 (FL, Apt, Suite, etc.)"
                      v-model="toAddress.address2" maxlength="45" @input="onTouched()"></b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <zip-code-input
                      :class="['form-control', { 'is-invalid': dirty && !toAddress.postal_code || checkAddressLineLength }]"
                      placeholder="Postal Code" v-model="toAddress.postal_code" :formatZip="toAddress.country === 'US'"
                      name="toPostal" @change="getCityState(toAddress.postal_code, 'shipto')"></zip-code-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="text"
                      :class="['form-control', { 'is-invalid': dirty && !toAddress.city || checkAddressLineLength }]"
                      placeholder="City" v-model="toAddress.city" name="toCity" @input="onTouched()" @change="onChanged">
                    </b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="text"
                      :class="['form-control', { 'is-invalid': dirty && !toAddress.province || checkAddressLineLength }]"
                      placeholder="State/Province" v-model="toAddress.province" name="toState" @input="onTouched()"
                      @change="onChanged"></b-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-form-select v-model="toAddress.country" :options="countryOptions"
                      :class="['form-control', 'custom-dropdown', { 'is-invalid': !toAddress.country }]"
                      placeholder="Country" name="toCountry" @input="val => {
                        selectedService = '';
                        selectedPackage = '';
                        errors.items = []
                        clearRates();
                      }" @change="onChanged" />
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="tel" class="form-control" placeholder="Phone Number" v-model="toAddress.phone"
                      maxlength="25" name="phone" @input="onTouched(false)"></b-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="email" class="form-control" @input="onTouched(false)" placeholder="Email Address"
                      v-model="toAddress.email"></b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <span class="verify-btn">
                <b-btn @click="verifyAddress" size="sm" class="btn-light-blue-outline mr-2">
                  <img class="verifyImg" src="/images/icons/verify-address-blue.png">
                  Verify Address
                </b-btn>
                <b-btn @click="saveAddress" size="sm" class="btn-light-blue-outline">
                  <img class="verifyImg" src="/images/icons/save-address-blue.png">
                  Save Address
                </b-btn>
              </span>
            </div>
          </div>
          <!-- SHIPPING DETAILS -->
          <!-- PACKAGE DETAILS -->
          <div class="card">
            <div class="card-header blue">
              <b-row>
                <b-col>Package Details</b-col>
                <b-col>
                  <b-button :disabled="isFieldRequired || checkAddressLineLength" :class="['btn-grad', 'pull-right']"
                    size="sm" style="margin-top: 2px; margin-right: 5px; background-color:#ff4a63; color: white; "
                    v-show="dw_set" @click="manualUpdateRate">
                    <i class="fas fa-sync"></i>Update Rate
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div class="card-body">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <product-select ref="productSelect" :disabled="isFieldRequired" :country="country"
                      :product_data="product_data" v-model="selectedProduct" @change="onChangeProduct"
                      @clear="onProductClear" @save="onProductSave"></product-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <!-- service class options -->
                    <b-select :disabled="isFieldRequired" :options="serviceOptions" v-model="selectedService"
                      :class="['form-control', 'custom-dropdown', { 'is-invalid': dirty && !selectedService }]"
                      @change="onServiceClassChange" name="service">
                      <template slot="first">
                        <option :value="''" disabled>Select Service Class</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <!-- package options -->
                    <b-select :options="packageOptions"
                      :class="['form-control', 'custom-dropdown', { 'is-invalid': dirty && !selectedPackage }]"
                      :disabled="isFieldRequired || !selectedService" v-model="selectedPackage" name="package"
                      @change="onPackageChange">
                      <template slot="first">
                        <option :value="''" disabled>Select Package Type</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <!-- MY PACKAGING -->
                    <b-select :options="dimensionsPresetOptions" v-model="tmpMyPkg"
                      :disabled="isFieldRequired || !(dimensionsPresetOptions.length > 1)" class="form-control"
                      name="customsContentType" @change="onPackagingSelected">
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <!-- WEIGHT -->
                <b-col sm="2" lg="1">
                  <label class="p-1">
                    <b-img src="/images/icons/wgt-sm.png" width="25" v-b-tooltip.hover title="Weight" />
                  </label>
                </b-col>
                <b-col sm="5" lg="2">
                  <b-form-group>
                    <b-form-input type="number" placeholder="LB"
                      :class="['form-control', { 'is-invalid': dirty && noWeight && !noLB }]" v-model="weight.lb"
                      :disabled="isFieldRequired || noLB" @change="setWeight" @input="clearRates"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="5" lg="2">
                  <b-form-group>
                    <input type="number" placeholder="OZ" :class="['form-control', { 'is-invalid': dirty && noWeight }]"
                      :disabled="isFieldRequired" @change="setWeight" @input="clearRates" v-model="weight.oz" />
                  </b-form-group>
                </b-col>
                <b-col sm="2" lg="1">
                  <label class="pull-right p-1">
                    <b-img src="/images/icons/dim-sm.png" width="25" v-b-tooltip.hover title="Dimensions" />
                  </label>
                </b-col>
                <!-- DIMENSION -->
                <b-col sm="3" lg="2">
                  <b-form-group>
                    <input :disabled="isDimAllowed || isFieldRequired" type="number"
                      :class="['form-control', { 'is-invalid': dirty && !checkDimensions }]" placeholder="L"
                      v-model="package.length" @change="onChangeDimensions()" />
                  </b-form-group>
                </b-col>
                <b-col sm="3" lg="2">
                  <b-form-group>
                    <input :disabled="isDimAllowed || isFieldRequired" type="number"
                      :class="['form-control', { 'is-invalid': dirty && !checkDimensions }]" placeholder="W"
                      v-model="package.width" @change="onChangeDimensions()" />
                  </b-form-group>
                </b-col>
                <b-col sm="3" lg="2">
                  <b-form-group>
                    <input :disabled="isDimAllowed || isFieldRequired || selectedPackage === 'SOFTPACK'" type="number"
                      :class="['form-control', { 'is-invalid': dirty && !checkDimensions }]" placeholder="H"
                      v-model="package.height" @change="onChangeDimensions()" />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </div>
          </div>
          <!-- PACKAGE DETAILS -->
        </div>
        <!-- COLUMN 1 -->

        <!-- COLUMN 2 -->
        <div class="col-md-6">
          <!-- OPTIONAL FIELDS -->
          <div class="card mb-3">
            <b-card-header class="blue"> Optional Fields </b-card-header>
            <b-card-body class="pb-2">
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input-group class="default">
                      <b-form-input type="text" placeholder="Account ID Lookup" v-model="acct_id"
                        @keypress.enter="findAcctID" maxlength="100"></b-form-input>
                      <b-input-group-append>
                        <b-btn class="default btn-blue" style="opacity: 1; font-size: 11px !important;"
                          @click="findAcctID" :disabled="!acct_id">
                          <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-form-input type="text" placeholder="Description" v-model="description" maxlength="100"
                      @input="onTouched(false)"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-input type="text" class="form-control" placeholder="Custom Field 1 (Prints on Label)"
                      maxlength="40" v-model="order.label_sticky" :disabled="isInternational" @input="onTouched(false)">
                    </b-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input type="text" class="form-control" placeholder="Custom Field 2 (Prints on Label)"
                      maxlength="40" v-model="order.label_sticky_2" :disabled="isInternational"
                      @input="onTouched(false)"></b-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-dropdown ref="marketplaceDropdown" :text="marketplaceText" class="marketplacesDropdown">
                    <b-dropdown-form class="w-100 pl-2" v-for="m in marketplaceOptions" :key="m.text">
                      <div class="d-flex justify-content-between">
                        <a class="row no-gutters justify-content-between align-items-center w-100 cursor-pointer m-button"
                          @click="setMarketplace(m)">
                          <b-col sm="auto" class="d-flex align-items-center">
                            <div style="width: 22px;">
                              <img :src="m.img" :width="m.width">
                            </div>
                            <span class="ml-2">{{ m.text }}</span>
                          </b-col>
                          <b-col sm="auto">
                            <span class="mr-4 pr-2" v-if="m.is_default">(default)</span>
                          </b-col>
                        </a>
                        <b-form-checkbox :checked="m.is_default" :value="1" :unchecked-value="0"
                          class="cursor-pointer p-0 m-0" @change="setDefaultMarketplace(m.value)"></b-form-checkbox>
                      </div>
                    </b-dropdown-form>
                  </b-dropdown>
                </b-col>
              </b-form-row>
            </b-card-body>
          </div>
          <!-- OPTIONAL FIELDS -->

          <!-- ADDITIONAL SERVICES -->
          <div class="card mb-3">
            <div class="card-header blue">Additional Services</div>
            <div class="card-body">
              <b-form-row>
                <b-col>
                  <!-- DELIVERY CONF -->
                  <b-form-group>
                    <b-select class="form-control" v-model="selectedConfirm" :options="signatureOptions"
                      :disabled="!selectedPackage" @change="getRate">
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <!-- <b-col sm="6"> -->
                  <!-- DECLARED VALUE -->
                  <b-form-group>
                    <b-form-input
                      :class="['form-control', { 'is-invalid': dirty && (isInternational && !declaredValue) }]"
                      :disabled="isFieldRequired" v-model="declaredValue"
                      @keyup.native="(e) => { onKeyUpDeclaredValue(e, null) }" type="number" name="declared-value"
                      :placeholder="!isInternational ? 'Declared Value (Optional)' : 'Declared Value Of All Items'"
                      @change="onChangeDeclaredValue"></b-form-input>
                  </b-form-group>
                </b-col>
                <!-- <b-col sm="6">
                    <span>
                      Shipsurance (Available Balance {{numeral(shipsurance).format('$0,0.00')}})
                      <br>
                      <b-link to="/my-account/shipsurance">Click here</b-link> to add funds and view T&C
                    </span>
                  </b-col> -->
                <b-col>
                  <b-form-group>
                    <b-select class="form-control" v-model="selectedInsurance" @change="getRate"
                      :options="insuranceOptions" :disabled="!selectedPackage || !declaredValue">
                      <template slot="first">
                        <option :value="null">None (Default Insurance)</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <!-- CUSTOM FORM -->
                  <b-form-group>
                    <b-btn
                      :class="['form-control', 'default', 'customs-form', { 'is-invalid': verifyCustomForm && isInternational, 'is-required': isInternational && !isWithCustoms }]"
                      :disabled="!isInternationalValid" @click="onShowCustomsModal">Customs Form (International
                      Shipments Only)
                    </b-btn>
                  </b-form-group>
                </b-col>
                <b-col>
                  <!-- POSTMARK DATE -->
                  <b-input-group class="default">
                    <template v-slot:append>
                      <DatePicker class="form-control" :disabled="isFieldRequired" v-model="order.future_shipping_date" :config="{
                          format: 'YYYY-MM-DD',
                          minDate: moment(),
                          maxDate: moment().add('7', 'days'),
                        }" />
                    </template>
                  </b-input-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <b-select class="form-control" :disabled="isHazmatAllowed || isFieldRequired" v-model="selectedHazmat">
                      <template slot="first">
                        <option :value="null">Hazmat Type (Optional)</option>
                        <option value="Air Eligible Ethanol">Authorized Fragrance and Hand Sanitizer Shipments</option>
                        <option :disabled="isHazmatOptionAllowed" value="Lighters">Authorized Lighters - (Ground Advantage Only)</option>
                        <option value="Div 6.2 Biological Materials">Biological Materials - Lab kits, Authorized COVID Test Kit Returns</option>
                        <option value="Class 8 Air Eligible Corrosive Materials">Cleaning or Tree/Weed Killing Compounds</option>
                        <option value="Class 9 Dry Ice">Dry Ice Package</option>
                        <option value="Class 9 Lithium Battery Unmarked">Electronic Devices Installed With Lithium Batteries (No Marking)</option>
                        <option value="Class 9 Lithium Battery with New Device">Electronic Devices With Lithium Batteries (UN3481 or UN3091)</option>
                        <option value="Excepted Quantity Provision">Excepted Quantity Provision Package - Environmentally Hazardous Materials</option>
                        <option :disabled="isHazmatOptionAllowed" value="Ground Only Hazardous Materials">For Items That Are Not Listed, But Are Restricted To Surface Only - (Ground Advantage Only)</option>
                        <option value="Div 5.1 Hydrogen Peroxide 8 to 20 Percent">Hydrogen Peroxide (8 to 20% Concentration)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Limited Quantity Ground Only">LTD QTY Package - Cosmetics, Cleaning Products, Paints, Gas - (Ground Advantage Only)</option>
                        <option value="Class 9 Magnetized Materials">Magnetized Materials</option>
                        <option :disabled="isHazmatOptionAllowed" value="Div 4.1 Mailable Flammable Solids">Mailable Flammable Solids, Matches - (Ground Advantage Only)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 9 Lithium Battery Marked Ground Only">Marked Lithium Battery (UN3480 or UN3090) - (Ground Advantage Only)</option>
                        <option value="Consumer Commodity">Non-Flammable Aerosols, Flammable Combustible Liquids, Toxic Substance</option>
                        <option value="Div 5.2 Organic Peroxides">Organic Peroxides Package</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 7 Radioactive Materials">Radioactive Materials, Minerals, Gun sights - (Ground Advantage Only)</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 3">Sanitizer, Alcohol, Flammable Liquids - (Ground Advantage Only)</option>
                        <option value="Class 8 Sealed Lead Acid Battery">Sealed Lead Acid Batteries</option>
                        <option :disabled="isHazmatOptionAllowed" value="Small Quantity Provision">Small Quantity Provision Package - (Ground Advantage Only)</option>
                        <option value="Div 6.1 Toxic Materials">Toxic Materials - Pesticides, Herbicides, etc.</option>
                        <option :disabled="isHazmatOptionAllowed" value="Class 1 Toy Propellant or Safety Fuse">Toy Propellant/Safety Fuse - (Ground Advantage Only)</option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </div>
          </div>
          <!-- ADDITIONAL SERVICES -->

          <!-- POSTAGE SUMMARY -->
          <div class="card mb-3">
            <div class="card-header">
              <b-row>
                <b-col> Postage Summary </b-col>
                <b-col>
                  <b-btn class="btn-light-blue-outline pull-right" size="sm" style="margin-top: 1px" variant="warning"
                    @click="onClickClearAll">Clear All Fields</b-btn>
                </b-col>
              </b-row>
            </div>
            <table class="table borderless new-shipment shipping-info">
              <tbody v-if="(rate.alternateBaseCharge || rate.baseCharge)">
                <tr>
                  <th class>Shipping Rate:</th>
                  <td class="pull-right text-right">
                    <span :class="rate_style" v-if="rate_msg">{{ rate_msg }}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;{{ numeral((rate.alternateBaseCharge || rate.baseCharge)).format('$0,0.00')
                    }}
                  </td>
                </tr>
                <tr v-if="surcharge">
                  <th class>Surcharge:</th>
                  <td class="pull-right text-right">
                    <span class="rate-danger" v-if="surcharge_msg">{{ surcharge_msg }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    {{ numeral(surcharge).format('$0,0.00') }}
                  </td>
                </tr>
                <tr v-for="rateComponent in rateComponents" :key="rateComponent.specialServiceId">
                  <th class>{{ rateComponent.specialServiceName }}:</th>
                  <td class="pull-right"> {{ rateComponentFee(rateComponent) }} </td>
                </tr>
                <tr v-if="print_option !== 'return'">
                  <th class>Estimated Delivery Date:</th>
                  <td class="pull-right"> {{ deliveryEstimate }} </td>
                </tr>
                <tr :class="[(rate.alternateBaseCharge || rate.baseCharge) ? 'bg-green' : 'bg-light']">
                  <th class="font-weight-bold">
                    <em v-if="print_option === 'return'">
                      Estimated Total Cost:
                    </em>
                    <span v-else>
                      Total Cost:
                    </span>
                  </th>
                  <td class="font-weight-bold pull-right">
                    <em v-if="print_option === 'return'">
                      {{ numeral((rate.alternateTotalCharge || rate.totalCarrierCharge) +
                        parseFloat(insurance_price)).format('$0,0.00')
                      }}
                    </em>
                    <span v-else>
                      {{ numeral((rate.alternateTotalCharge || rate.totalCarrierCharge) +
                        parseFloat(insurance_price)).format('$0,0.00')
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <th class>Shipping Rate:</th>
                  <td class="pull-right">{{ numeral(0).format('$0,0.00') }}</td>
                </tr>
                <tr>
                  <th class>Signature:</th>
                  <td class="pull-right">None</td>
                </tr>
                <tr>
                  <th class>Estimated Delivery Date:</th>
                  <td class="pull-right"> N/A </td>
                </tr>
                <tr :class="[dirty ? 'alert-danger' : 'bg-gray']">
                  <th>Total Cost:</th>
                  <td class="pull-right">{{ numeral(0).format('$0,0.00') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- POSTAGE SUMMARY -->
          <!-- SHIPPING OPTIONS -->
          <div class="card mb-0">
            <div class="card-header">
              <b-row>
                <b-col> Shipping Options </b-col>
                <b-col>
                  <b-form-checkbox class="pull-right" v-model="autoClearFields" value='yes' unchecked-value='no'>
                    Automatically Clear Fields After Printing
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </div>
            <div class="card-body">
              <b-row align-v="center" no-gutters>
                <b-col sm="8">
                  <b-select v-model="print_option" class="shipping_options" :options="shippingSelectOptions"></b-select>
                </b-col>
                <b-col sm="2" class="text-center">
                  <div class="ship-button d-inline-block">
                    <img :disabled="!(rate.alternateBaseCharge || rate.baseCharge)"
                      :src="!(rate.alternateBaseCharge || rate.baseCharge) ? '/images/button-print-disabled.png' : '/images/button-print.png'"
                      width="50" @click="printLabel(print_option)" />
                  </div>
                </b-col>
                <b-col sm="2">
                  <div class="truck d-inline-block">
                    <img src="/images/button-ship.png" width="75"
                      :class="{ 'rumble': status === 'shipping', 'animating': status === 'shipped' }" />
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <!-- SHIPPING OPTIONS -->
        </div>
        <!-- COLUMN 2 -->
      </div>
    </form>

    <DropInAddress ref="addressModal" :address="toAddress" @save="onAddressSave" />
  </div>
</template>

<style lang="scss">
.tooltip-text {
  visibility: hidden;
  position: fixed;
  width: 750px;
  color: white;
  font-size: 12px;
  background-color: #192733;
  border-radius: 10px;
  padding: 10px 15px 10px 15px;
  z-index: 3;
}

.tooltip-text::before {
  content: "";
  position: absolute;
  transform: rotate(45deg);
  background-color: #192733;
  z-index: 1;
}

.hover-text:hover .tooltip-text {
  visibility: visible;
}

#top {
  top: 35%;
  left: 25%;
}

#top::before {
  top: 80%;
  left: 45%;
}

#down {
  top: 32%;
  left: 47%;
}

#down::before {
  top: 80%;
  left: 45%;
}

.hover-text {
  position: absolute;
  display: inline-block;
  font-family: Arial;
  text-align: left;
}
ul.no-bullets {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.marketplacesDropdown {
  width: 100%;

  .btn.dropdown-toggle {
    padding: 8px !important;
    border-radius: .25rem !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-color: #ced4da;
    color: #495057;
  }

  .dropdown-item {
    padding: 2px 4px;
  }

  ul {
    width: 100%;
    max-height: 200px;
    overflow: hidden auto;

    li:hover {
      background: #e9ecef;
    }

    .custom-checkbox {
      input {
        margin-left: -1.2rem;
      }
    }
  }
}

.bs-tooltip-left .tooltip-inner {
  text-align: left !important;
}
</style>
<style lang="scss" scoped>
.rate-success {
  color: #00b050;
}

.rate-danger {
  color: #dc3545;
}

.custom-dropdown {
  border-color: #ced4da !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0    3h4z'/%3e%3c/svg%3e") !important;
}

.customs-form {
  color: #495057 !important;
  text-align: left;
  border-color: #ced4da !important;
  background-color: #e9ecef !important;

  &.is-required,
  &.is-invalid {
    background-color: #f8e2e2 !important;
  }
}

.form-row.address-dropdowns {
  margin-bottom: 10px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 15px;
  margin-top: -20px;
  padding-right: 0px;
  padding-top: 5px;
}

.order-summary {
  legend.col-form-legend {
    padding-left: 0;
    padding-right: 0;
    text-align: left;
  }
}

.origin-address {
  background-image: none !important;
}
</style>

<style lang="scss" scoped>
// .origin-selected {
//   border-radius: 4px;
//   background-color: #ffc93a;
//   // font-weight: bold;
//   &:focus {
//     background-color: #ffc93a;
//   }
// }

option:disabled {
  color: rgb(215, 215, 215) !important;
}

.card {
  font-size: 0.75rem !important;

  .card-header {
    font-size: 0.95rem !important;
    padding: 0.10rem 1rem;

    .btn {
      padding: 1px 8px;
    }
  }

  .form-group {
    margin-bottom: 0.5rem;
  }

  input,
  select,
  button,
  label,
  .input-group-text {
    font-size: 0.75rem !important;
  }

  .dropdown {
    .dropdown-toggle {
      padding: 2px;
    }
  }
}

@keyframes rumble {
  0% {
    transform: translateX(0);
  }

  33% {
    transform: translateX(0.5px);
  }

  66% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-0.5px);
  }
}

@keyframes drive {
  0% {
    transform: translateX(0);
  }

  1% {
    transform: translateX(2px);
  }

  2% {
    transform: translateX(-2px);
  }

  3% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(0);
  }

  35% {
    transform: translateX(0);
  }

  60% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(500px);
  }
}

@keyframes return {
  0% {
    transform: translateX(-330px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ship-button {
  position: relative;
  text-align: left;

  img {
    cursor: pointer;
    width: 50px;
    height: auto;
  }
}

.truck {
  position: relative;

  img {
    cursor: pointer;
    width: 75px;
    height: auto;

    &.rumble {
      animation: rumble 0.1s ease-in-out infinite;
      cursor: wait;
    }

    &.animating {
      animation: drive 2s 0s ease-in, return 1s 2.33s ease-out;
      animation-fill-mode: forwards;
      cursor: wait;
    }
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.borderless {

  td,
  th,
  .list-group-item {
    border: none;
  }
}

.ship-to {
  .form-group {
    margin-bottom: 0.5rem;
  }
}

.order-details--container {
  .card {
    .card-header {
      color: #fff;
      font-size: 17px;

      >*:not(.form-control) {
        color: #fff;
      }

      .btn {
        margin-top: 0;

        .glyphicon {
          vertical-align: center;
        }

        &.collapsed {
          .glyphicon-chevron-up {
            transform: rotate(180deg);
          }
        }
      }
    }

    .card-body {
      min-height: 0px; //540px
    }

    .card-body,
    #additional-services-collapse,
    & {
      >table {
        margin-bottom: 0;

        tbody {
          padding-top: 10px;
        }

        td:first-child,
        th:first-child {
          padding-left: 20px;
        }

        td:last-child,
        th:last-child {
          padding-right: 20px;
        }

        td,
        th {
          padding-top: 6px;
          padding-bottom: 6px;
        }
      }
    }
  }

  .table {
    &:last-child {
      margin-bottom: 0;
    }

    th {
      //padding: 5px 15px 5px 0;
      padding-right: 0;
    }

    td {
      //padding: 5px 0;

      .form-group {
        margin-bottom: 0;

        /*& + .form-group {
          margin-top: 10px;
        }*/
      }
    }
  }
}

.size-box-wrap {
  display: flex;
  flex-wrap: wrap;
}

.size-box {
  max-width: 35px;
  margin-right: 3px;
  display: inline-block;
  float: left;

  @media screen and (min-width: 1600px) {
    max-width: 39px;
  }

  @media screen and (min-width: 1800px) {
    max-width: 50px;
  }
}

.size-box-in {
  display: inline-block;
  margin-right: 5px;
}

.size-box-dropdown {
  display: inline-block;
}

.address-help {
  position: absolute;
  font-size: 1.4rem;
  right: 5px;
  top: 5px;
  color: #dc3545;
}

.shipsurance span {
  position: absolute;
  top: 7px;
  right: 9px;
}
</style>
<script>
import vSelect from "../../components/VueSelect";
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import CountrySelect from "../../components/Form/CountrySelect";
import PausableDialog from "../../components/Dialogs/Pausable";
import { mapGetters, mapActions, mapMutations } from "vuex";
import DatePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import numeral from "numeral"
import hash from "object-hash";
import formatters from "../../formatters";
import sorting from "../../data/sorting";
import countries from "../../data/countries";
import insurance from "../../data/insurance";
import cubicWeight from "../../data/cubic-weight";
import validations from "./NewShipment/validations";
import GoogleAutoComplete from "../../components/GoogleAutoComplete";
import Validation from '../../mixins/Validation';
import lStore from './Mixins/lStore';
import DropInAddress from "../../components/Modals/DropInAddress";
import { shippingOptions } from "../../data/shipping-options"
import marketplaces from "../../data/marketplaces";

let initialData = {};
// TURNED OFF VALIDATION SINCE IT"S NOT REALLY WORKING IN THE FIRST PLACET
export default {
  mixins: [Validation],
  components: {
    LoadingSpinner,
    Alerts,
    CountrySelect,
    vSelect,
    DatePicker,
    GoogleAutoComplete,
    DropInAddress,
  },
  // props: {
  //   name: {
  //     default: 0
  //   },
  //   addr: {
  //     default: null
  //   },
  //   ordr: {
  //     type: Object,
  //     default: null
  //   }
  // },
  async created() {
    this.getRate = _.throttle(this.getRate, 1000);

    setTimeout(() => {
      this.canUpdateOrder = true;
    }, 500);

    this.refreshUserBalance();

    // GETTING MARKETPLACES
    this.getMarketplace()
    // GETTING ORIGIN
    await this.fetchOrigins();
    // Existing order
    // if (this.order && this.order.id) {
    //   this.syncFromOrder(this.order);
    // }

    // Default dimensions
    if (
      !this.order.id &&
      this.user.default_dimension_id &&
      !_.isEmpty(this.user.default_dimension) &&
      !this.$route.query.reset
    ) {
      this.package = {
        width: this.user.default_dimension.width,
        height: this.user.default_dimension.height,
        length: this.user.default_dimension.length
      };
    }

    if (this.$route.query.reset) {
      this.order = {};
    }

    if (this.$route.query.id) {
      await this.copyOrder(this.$route.query.id);
    }
    // this.fetchOrigins();

    const dict = {
      custom: {
        toAddress: {
          required: "Your Address is empty"
        },
        toCity: {
          required: "Your City is empty"
        },
        toState: {
          required: "Your State/Province is empty"
        },
        toPostal: {
          required: "Your Postal code is empty"
        },
        fromCountry: {
          required: "Your Country is empty"
        },
        fromAddress: {
          required: "Your Address is empty"
        },
        fromCity: {
          required: "Your City is empty"
        },
        fromState: {
          required: "Your State/Province is empty"
        },
        fromPostal: {
          required: "Your Postal code is empty"
        },
        fromCountry: {
          required: "Your Country is empty"
        }
      }
    };
    this.$validator.localize("en", dict);
    initialData = { ...this.$data };
  },
  data() {
    return {
      autoClearFields: 'yes',
      marketplaceOptions: [],
      acct_id: null,
      rate_style: null,
      rate_msg: null,
      error_msg: null,
      dirty: false,
      status: "waiting", // shipping, shipped
      tmpAddress: null,
      tmpMyPkg: '0x0x0',
      print_option: "label",
      showCustomsModal: false,
      validCustomForm: false,
      isValueChanged: false,
      isWeightChanged: false,
      err_msg: "",
      customs: {
        content_type: 'MERCHANDISE',
        sender_signature: "",
        items: []
      },
      lines: [{
        origin: null,
      }], // for customs items
      setCustomsSignature: false,
      eu: [ "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","NO","PL","PT","RO","SK","SI","ES","SE","CH"],
      deliveryEstimate: '',
      declaredValue: null,
      options: ["1 Test St"],
      selectedConfirm: "DelCon",
      isLoading: false,
      canUpdateOrder: false,
      getRateTimer: null,
      rates: {},
      rate: {},
      tracking_price: 0,
      insurance_price: 0,
      surcharge: 0,
      surcharge_msg: null,
      items: [],
      description: "",
      servicesList: {},
      service: {},
      selectedService: "",
      selectedPackage: "",
      selectedAddress: "",
      order_items: [],
      selectedInsurance: null,
      selectedHazmat: null,
      isDeliveryEU: false,
      selectedInsuranceInputs: {},
      selectedDimensionsPreset: null,
      order: {},
      services: [
        { name: "USPS First Class", value: "FCM" },
        { name: "USPS Priority", value: "PM" },
        { name: "USPS Express ", value: "EM" }
      ],
      packages: [
        { name: "Package", value: "PKG" },
        { name: "Irregular Package", value: "IRRPKG" },
        { name: "Flat Rate Envelope", value: "FRE" },
        { name: "Small Flat Rate Box", value: "SFRB" },
        { name: "Medium Flat Rate Box 2", value: "FRB" },
        { name: "Large Flat Rate Box", value: "LFRB" },
        { name: "Flat Rate Padded Envelope", value: "PFRENV" },
        { name: "Flat Rate Legal Envelope", value: "LGLFRENV" },
        { name: "Military Large Flat Rate Box", value: "MLFRB" },
      ],
      origin_addresses: [],
      shipper_addresses: [],
      selected: null,
      selectedOrigin: null,
      hasDefaultOrigin: false,
      addresses: [], // customer addresses
      selectedRecipient: null,
      selectedProduct: null,
      toAddress: {
        address: '',
        country: "US",
        province: ''
      },
      // suggestedAddresses: [],
      shipto: {},
      postmark_date: null,
      weight: { lb: null, oz: null },
      weight_set: false,
      dim_set: false,
      dw_set: false,
      noLB: false,
      weight_measure: "OZ",
      dimensions_preset: null,
      package: { length: null, width: null, height: null },
      service_rules: {},

      selectedMarketplace: 4,
      marketplaceText: 'Marketplace Reference',
      marketplaces: [],
      selectedShippingOptions: [],
      shippingSelectOptions: [],
    };
  },
  validations,
  async mounted() {
    this.selectedShippingOptions = this.user.shipping_options;
    if (this.user.shipping_options.includes("LBL")) {
      this.print_option = 'label';
    } else if (this.user.shipping_options.includes("SBR")) {
      this.print_option = 'return';
    } else if (this.user.shipping_options.includes("RLBL")) {
      this.print_option = 'rlabel';
    } else if (this.user.shipping_options.includes("LBLRLBL")) {
      this.print_option = 'rboth';
    } else if (this.user.shipping_options.includes("LBLSBR")) {
      this.print_option = 'both';
    } else if (this.user.shipping_options.includes("LBLPDF")) {
      this.print_option = 'pdf';
    } else {
      this.print_option = 'test'
    }
    // copy data order if there's an ordr prop else use empty obj
    // if(this.ordr !== null) this.order = this.ordr;
    const addr = this.$route.query.addr;
    this.customs.sender_signature = this.user.name;
    if (addr) {
      this.selectedRecipient = addr;
      await this.onChangeRecipient(addr);
    }
    // if (this.user.enable_shipsurance) {
    //   this.selectedInsurance = 'shipsurance';
    // }
    const rs = this.$route.query.rs;
    if (rs) {
      await this.replicateShipment(rs)
    }
    // console.log("Get Origin")
    await this.fetchOrigins();
    // console.log("Finish Origin")

    // GETTING MARKETPLACES
    await this.getMarketplace()
    await this.setSelectedShippingOptions();
  },
  watch: {
    signatureOptions: function (val) {
      this.$nextTick(() => {
        this.onChangeSignatureOptions();
      });
    },
    'order.future_shipping_date': function (before, after) {
      if (before !== after) {
        this.getRate();
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee_name: "getEmployeeName",
      getCarrierRules: "getCarrierRules",
      getSignatureCarrierRules: "getSignatureCarrierRules",
      getInsuranceCarrierRules: "getInsuranceCarrierRules",
      shipping_services: "getShippingServices",
      getShippingService: "getShippingService",
      customsName: "getCustomsName",
      recipients: "recipients",
      products: "products",
      shipsurance: "getShipsurance",
    }),
    product_data() {
      return {
        selectedProduct: this.order_items.length ? this.order_items : this.selectedProduct,
        selectedService: this.selectedService,
        selectedPackage: this.selectedPackage,
        tmpMyPkg: this.tmpMyPkg,
        weight: this.weight,
        dimensions: {
          l: this.package.length,
          w: this.package.width,
          h: this.package.height,
        }
      }
    },
    noWeight() {
      const { oz, lb } = this.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },
    isAddressValid() {
      return true;
      // NO NEED TO CHECK FOR NUMERIC FOR DOMESTIC ADDRESS
      // if (this.isInternational) return true;
      // const re = /\d/;
      // return re.test(this.toAddress.address)
    },
    verifyCustomForm() {
      this.updateCustomForm();
      let total_price = 0,
        total_weight = 0,
        objEmpty = false,
        declaredWeight = parseFloat(this.weight.lb) * 16 + parseFloat(this.weight.oz);
      this.err_msg = "";
      this.customs.items.forEach(function loop(obj) {
        if (loop.stop || typeof (obj) == "undefined") {
          objEmpty = true; return;
        };
        objEmpty = false;
        total_price += obj.unitPrice;
        total_weight += obj.unitWeight.weight;
        if (!parseFloat(obj.unitWeight.weight)) {
          total_weight = 0; loop.stop = true;
        } else if (!parseFloat(obj.unitPrice)) {
          total_price = 0; loop.stop = true;
        }
      })
      let errorCount = 0
      let errorLength = 0
      let tariff = ""
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].tariff == "" || !this.lines[i].tariff) {
          errorCount = errorCount + 1
        }
        if (this.lines[i].origin == null) {
          errorCount = errorCount + 1
        }
        if (this.lines[i].tariff) {
          tariff = this.lines[i].tariff
          if (tariff.length < 6) {
            errorLength = 1
          }
        }
      }
      this.validCustomForm = true;
      if (parseFloat(this.declaredValue) != parseFloat(total_price) || parseFloat(total_weight) > parseFloat(declaredWeight)) {
        this.validCustomForm = false;
      }
      if (!this.customs.content_type) {
        this.err_msg = "Please select a package content type!";
      }
      else if (!this.customs.sender_signature) {
        this.err_msg = "Please enter full name in custom form!";
      }
      else if (objEmpty) {
        this.err_msg = "Fields that are required can't be empty!";
      }
      else if (this.isValueChanged && total_price && parseFloat(total_price) != parseFloat(this.declaredValue)) {
        this.err_msg = `Total declared value of additional services does not match total value entered in customs form.`;
      }
      else if (this.isWeightChanged && total_weight && parseFloat(total_weight) != parseFloat(declaredWeight)) {
        this.err_msg = `Total weight of package details does not match total weight entered in customs form.`;
      }
      else if (!parseFloat(total_price)) {
        this.err_msg = "Custom form price can't be empty!";
      }
      else if (!parseFloat(total_weight)) {
        this.err_msg = "Custom form weight can't be empty!";
      }
      else if (this.isDeliveryEU && errorCount) {
        this.err_msg = "Custom form Tariff and Origin can't be empty for EU shipping!";
      }
      else if (parseFloat(total_price) != parseFloat(this.declaredValue)) {
        this.err_msg = `Total declared value of additional services does not match total value entered in customs form.`;
      }
      else if (parseFloat(total_weight) != parseFloat(declaredWeight)) {
        this.err_msg = `Total weight of package details does not match total weight entered in customs form.`;
      }
      else if (this.isDeliveryEU && errorLength > 0) {
        this.err_msg = "HS Tariff # should be a minimum of 6 digits";
      }
      if (this.isValueChanged) {
        this.isValueChanged = false;
      }
      if (this.isWeightChanged) {
        this.isWeightChanged = false;
      }
      // if (this.validCustomForm) this.getRate();
      return (this.err_msg) ? true : false;
    },
    isInternationalValid() {
      let declaredWeight = parseFloat(this.weight.lb) * 16 + parseFloat(this.weight.oz)
      if (this.isInternational && this.declaredValue && declaredWeight) return true
      return false
    },
    isFullNameRequired() {
      if (this.isInternational && !this.toAddress.company) {
        return this.toAddress.last_name && this.toAddress.first_name ? false : true;
      }
      return false;
    },
    isFieldRequired() {
      if (
        !(this.toAddress.first_name || this.toAddress.last_name || this.toAddress.company) || !this.toAddress.address ||
        !this.toAddress.postal_code || !this.toAddress.province || !this.toAddress.city || !this.toAddress.country
      ) return true
      return false
    },
    checkAddressLineLength() {
      let addressLength = 0
      if (this.toAddress.postal_code) {
        addressLength += this.toAddress.postal_code.length
      }
      if (this.toAddress.province) {
        addressLength += this.toAddress.province.length
      }
      if (this.toAddress.city) {
        addressLength += this.toAddress.city.length
      }
      if (addressLength > 45) {
        return true
      }
      return false
    },
    checkDimensions() {
      const { height, width, length } = this.package;
      // console.log("hwl", height, width, length);

      const hasAll = height && width && length;
      if (this.selectedPackage === "SOFTPACK") {
        this.package.height = 1
        if (!hasAll) return false;
        return true;
      } else if (this.selectedPackage === "IRRPKG") {
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(height), parseInt(width), parseInt(length)];
        // console.log(dim)
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        // console.log("hasNull", hasNull, "hasVal", hasVal)
        if (hasNull && hasVal) return false
        return true;
      }
    },
    isDimAllowed() {
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG", "IRRPKG"].includes(this.selectedPackage)) return false;
        this.package.length = null;
        this.package.height = null;
        this.package.width = null;
        this.dw_set = true;
        return true;
      }
      return false;
    },
    isHazmatAllowed() {
      if (this.selectedService == "MEDIA") {
        this.selectedHazmat = null
        return true
      }
      else return false
    },
    isHazmatOptionAllowed() {
      if (this.selectedService == "PM" || this.selectedService == "EM") {
        this.selectedHazmat = null
        return true
      }
      else return false
    },
    recipientOptions() {
      if (!this.recipients) {
        return [];
      }

      let recipients = { ...this.recipients };

      let options = _.map(recipients, address => {
        let label = address.first_name + " " + address.last_name;

        if (!_.isEmpty(address.company)) {
          label += " - " + address.company;
        }

        return {
          value: address.id,
          text: label
        };
      });
      // return _.concat({
      //   value:'',
      //   text: 'Search Recipient',
      // }, options);
      return options;
    },
    isWithCustoms() {
      if (this.customs.content_type && this.customs.sender_signature !== '' &&
        this.customs.items[0] != undefined && this.customs.items.length > 0) return true;
      return false;
    },
    isInternational() {
      if (this.toAddress == null) return false;
      // console.log("IS International check: ", this.toAddress);
      const { country, province } = this.toAddress;
      if (country && country.toUpperCase() == 'US') {
        if (province && ["AA", "AE", "AP", "AS", "FM", "GU", "MH", "MP", "PR", "PW", "VI", "UM"].includes(province.toUpperCase())) return true;
        return false;
      }
      return true;
    },
    cubic_pricing() {
      if (!this.rate || !this.rate.dimensionalWeight || !this.rate.dimensionalWeight.weight) {
        return false;
      }
      return true;
    },
    static() {
      if (this.order && [3, 4].includes(this.order.order_status_id)) {
        return true;
      }

      if (["shipping", "shipped"].includes(this.status)) {
        return true;
      }

      if (this.isLoading) {
        return true;
      }

      return false;
    },
    country() {
      let country = "US";

      if (this.toAddress && this.toAddress.country) {
        country = this.toAddress.country;
      }

      return country;
    },
    carrierRules: function () {
      return this.getCarrierRules(this.country);
    },
    serviceRules() {
      return this.carrierRules[this.selectedService] || [];
    },
    print_valid() {
      return !_.isEmpty(this.selectedService);
    },
    future_shipping_date_rules() {
      return {
        required: this.order.future_shipping
      };
    },
    dimensionsPresetOptions() {
      let options = this.user.dimensions
        ? this.user.dimensions.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Custom Packaging',
      }, options);
      return options;
    },
    countryOptions: countries.getSelectOptions,
    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(_.filter(options), "order");

        options = options.map(option => {
          let packageOptions = this.getPackageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        });

        return _.filter(options);
      } catch (e) {
        // console.error(e);
        return [];
      }
    },
    packageOptions() {
      if (
        _.isEmpty(this.selectedService) ||
        !this.serviceRules["parcelTypeRules"]
      ) {
        this.selectedPackage = '';
        return [];
      }

      return this.getPackageOptions(this.selectedService);
    },
    signatureOptions() {
      const rules = this.getSignatureCarrierRules(
        this.selectedService,
        this.selectedPackage,
        this.country,
        false
      );
      // if not
      if (!rules.length) {
        return [{
          value: 'DelCon',
          label: 'Delivery Confirmation (Default Tracking)',
          text: 'Delivery Confirmation (Default Tracking)'
        }];
      }

      let ruleOptions = rules.map(rule => {
        return {
          value: rule.specialServiceId,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
    insuranceOptions() {
      if (_.isEmpty(this.selectedService) || !this.user.shipsurance_terms) {
        return [];
      }

      return insurance.getSelectOptions();

      // Domestic shipment. Just return static options
      // if (this.country === "US") {
      //   return insurance.getSelectOptions();
      // }

      // // International. Use shipping rules
      // let rules = this.$store.getters.getInsuranceCarrierRules(
      //   this.selectedService,
      //   this.selectedPackage,
      //   this.country
      // );
      // const ruleOptions = rules.map(rule => {
      //   return {
      //     value: rule,
      //     label: rule.brandedName,
      //     text: rule.brandedName
      //   };
      // });

      // return ruleOptions;
    },
    insuranceId() {
      if (!this.selectedInsurance) {
        return null;
      }
      if (_.isString(this.selectedInsurance)) {
        return this.selectedInsurance;
      }
      if (this.selectedInsurance.specialServiceId) {
        return this.selectedInsurance.specialServiceId;
      }
      return null;
    },
    rateComponents() {
      if (!this.selectedService || !this.serviceRules) {
        return [];
      }

      let formatted = this.rate.specialServices
        .filter(specialService => {
          return ["DelCon", "Sig", "ADSIG", "ADSIGRD"].includes(
            specialService.specialServiceId
          );
        })
        .map(specialService => {
          if (specialService.specialServiceId === "DelCon") {
            specialService.specialServiceName = "Signature";
          } else if (specialService.specialServiceId === "Sig") {
            specialService.specialServiceName = "Signature";
          } else if (specialService.specialServiceId === "ADSIG") {
            specialService.specialServiceName = "Adult Signature";
          } else if (specialService.specialServiceId === "ADSIGRD") {
            specialService.specialServiceName = "Adult Signature with Restricted Delivery";
          }
          // else {
          //   specialService.specialServiceName =
          //     "PB Parcel Protection Insurance";
          // }
          return specialService;
        });

      // tracking
      const tracking = _.find(this.rate.specialServices, service =>
        ["DelCon", "Sig", "ADSIG", "ADSIGRD"].includes(service.specialServiceId)
      );
      if (!tracking) {
        formatted.push({
          specialServiceId: "Sig",
          specialServiceName: "Signature",
          fee: 0
        });
      } else {
        this.tracking_price = tracking.fee;
      }

      // shipsurance
      const insurance = _.find(this.rate.specialServices, service =>
        ["Ins"].includes(service.specialServiceId)
      );

      if (insurance) {
        formatted.push({
          specialServiceId: "Ins",
          specialServiceName: "Shipsurance",
          fee: insurance.fee
        });
        this.insurance_price = insurance.fee;
      }

      return formatted;
    },
    countrySelectOptions() {
      const cs = countries.getSelectOptions().filter(c => {
        return c.value !== null;
      });
      // _.concat({
      //   text: 'US (Origin)',
      //   value: 'US'
      // }, cs);
      return _.concat({
        text: 'Country of Origin',
        value: null
      }, cs);
    },
    // suggestedAddressesOptions() {
    //   return this.suggestedAddresses.map(address => {
    //     return {
    //       text: address.addressLines[0],
    //       value: address
    //     };
    //   });
    // },
  },
  methods: {
    ...mapActions(["addPrintJob", "refreshUserBalance", "refreshUser", "refreshShipsurance", "refreshShippingServices", "refreshCarrierRules", "refreshNotification"]),
    ...mapMutations(["setCustomsName"]),
    moment: moment,
    formatPrice: formatters.formatPrice,
    formatDate: formatters.date,
    /**
    async replicateShipment(id) {
      try {
        const { data } = await axios.get("/orders/" + id);
        console.log('replicating: ', data);

        // SET RECIPIENT INFO
        this.toAddress = {
          address: data.shipping_address.address,
          address2: data.shipping_address.address2,
          city: data.shipping_address.city,
          country: data.shipping_address.country,
          province: data.shipping_address.province,
          postal_code: data.shipping_address.postal_code,
          phone: data.shipping_address.phone,
          email: data.shipping_address.email,
          company: data.shipping_address.company,
          first_name: data.shipping_address.first_name,
          last_name: data.shipping_address.last_name,
        }
        this.description = data.description
        this.order.label_sticky = data.label_sticky
        this.order.label_sticky_2 = data.label_sticky_2

        // $nextTick doesn't work so I decided to use setTimeout instead
        // also delayed when the shipment is international for updated package details
        this.$nextTick(async () => {
          // SET ORIGIN
          console.log("ORIGINS", this.origin_addresses)
          console.log("data origin_id", this.origin_id)
          this.selected = this.origin_addresses.find(o => o.id === data.origin_id) || this.origin_addresses.find(o => o.is_default)
          console.log("SELECTED: ", this.selected);
          this.selectedOrigin = _.find(this.shipper_addresses, addr => addr.value == this.selected)

          // SET PACKAGE DETAILS
          this.selectedService = data.shipping_service.code
          this.selectedPackage = data.package_type
          this.weight = this.getWeight(data.total_weight)
          this.package = { length: data.package_length, width: data.package_width, height: data.package_height }

          // SET ADDITIONAL DETAILS
          this.selectedConfirm = data.confirmation
          this.declaredValue = data.declared_value

          await this.getRate();
        })
      } catch (error) {
        console.error('error', error)
      }
    },
    */
    onTouched(clear = true) {
      if (clear) {
        this.clearRates();
      }
      this.dirty = true;
      console.log('setting dirty on touched to: ', this.dirty);
    },
    async onChanged() {
      const coo = document.getElementById("customsOrigin");
      if(coo.value){
        coo.style.color = "#495057"
      }
      else{ coo.style.color = "#696868"}
      this.isDeliveryEU = false;
      if(this.eu.includes(this.toAddress.country)){      
        this.isDeliveryEU = true;
      }
      // console.log("this.toAddress.country", this.toAddress.country)
      this.clearRates();
      this.dirty = true;
      this.dw_set = true;

      if (this.user.enable_shipsurance && this.declaredValue) {
        this.selectedInsurance = 'shipsurance';
      }

      // set default marketplace
      const currentDefault = this.user.marketplaces ? this.user.marketplaces.find(u => u.is_default) : null
      if (currentDefault) {
        const mp = this.marketplaces.find(m => m.value === currentDefault.value)
        // console.log('Current default marketplace', mp);
        if (mp) {
          this.selectedMarketplace = mp.value
          this.marketplaceText = mp.text
        }
      }

      if (!this.selectedProduct && !this.isFieldRequired) {
        this.showDefaultPackageDetails()
      }
    },
    async showDefaultPackageDetails() {
      if (this.user.default_package && this.user.package_detail_json) {
        const user_package = JSON.parse(this.user.package_detail_json)
        this.selectedProduct = 'default'
        this.selectedService = user_package.selectedService
        this.selectedPackage = user_package.selectedPackage
        this.tmpMyPkg = user_package.tmpMyPkg || '0x0x0'
        this.weight = user_package.weight
        this.package = user_package.package
        this.selectedConfirm = user_package.selectedConfirm
        this.declaredValue = user_package.declaredValue
        this.selectedInsurance = user_package.selectedInsurance
        this.weight_set = true
        this.getRate();
      }
    },
    onServiceClassChange(val) {
      this.clearRates();

      this.selectedService = val;
      this.selectedPackage = 'PKG';
      this.selectedInsuranceInputs = null;

      if (!this.user.enable_shipsurance) {
        this.selectedInsurance = null;
      }

      // console.log("service class is: ", val);
      switch (val) {
        case "FCPIS":
          if (!this.noWeight) {
            const total_weight = ((this.weight.lb || 0) * 16) + (this.weight.oz || 0);
            if (total_weight > 64) {
              this.error_msg = "Maximum weight limit for First-Class Package International is 4lbs.";
              this.weight = Object.assign({}, { lb: 0, oz: 0 });
            }
          }
          break;
        case "FCM":
          this.noLB = true;
          this.weight.lb = 0;
          break;
        default:
          this.noLB = false;
      }
      if (this.dim_set || this.weight_set) {
        this.dw_set = true;
      }
    },
    rateComponentFee(rateObj) {
      // console.log('rate fee', rateObj, this.selectedConfirm);
      if (this.selectedService === 'EM' && rateObj.specialServiceName === 'Signature') {
        if (this.selectedConfirm === null) {
          return "Waived by Shipper"
        } else {
          return "Included"
        }
      }
      // console.log(rateObj.fee);
      return rateObj.fee > 0 ? numeral(rateObj.fee).format('$0,0.00') : 'None';
    },
    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },
    getPackageOptions(serviceId) {
      // console.log("SERVICE ID", serviceId);
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country,
        true // filter inactive mail classes
      );

      // Flat Rates, this needs to be updated annually
      const flatRates = {
        EM: { // Priority Mail Express
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: { // Priority Mail
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }

      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;

          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return options
      // return _.orderBy(options, "text");
    },
    getShippingPaid: function (shipping_lines, format = false) {
      let total = 0;
      for (let line of shipping_lines) {
        total += parseFloat(line.amount);
      }

      if (format) {
        return this.formatPrice(total);
      }

      return total;
    },
    async onPackagingSelected(val) {
      this.clearRates();

      // console.log('mypackaing', val);
      if (!val) return;
      const [l, w, h] = val.split('x');
      this.package = { length: parseInt(l), width: parseInt(w), height: parseInt(h) };
      if (!this.noWeight) {
        await this.getRate();
      }
    },
    // validate(name = null, getRate = true) {
    //   this.$nextTick(() => {
    //     try {
    //       this.$validator.validateAll().then(() => {
    //         if (getRate && this.errors.items.length === 0) {
    //           this.getRate();
    //         }
    //         this.errors.items = [];

    //         if (name) {
    //           this.$validator.validate(name);
    //         }
    //       });
    //     } catch (e) {
    //       console.log("Validation Error", e);
    //     }
    //   });
    // },
    // clearFeedback(name) {
    //   this.$validator.validate(name);
    // },
    addItem: function () {
      let vm = this;
      let item = {
        name: "",
        quantity: 1,
        price: ""
      };
      let items = vm.items;
      items.push(item);
      vm.items = items;
    },
    async copyOrder(orderId) {
      // console.log("Copy Order");
      this.LoadingSpinner = true;
      const { data } = await axios.get("/orders/" + orderId);
      console.log("data: ", data);
      await this.syncFromOrder(data);
      await this.$nextTick();
      await this.getRate();
      this.LoadingSpinner = false;
    },
    async fetchOrigins() {
      const response = await axios.get("user/addresses");
      if (response.data.length > 0) {
        const shipperAddr = response.data.map(or => {
          let nagan = `${or.first_name || ''} ${or.last_name || ''}`;
          if (nagan.trim() && or.company) nagan = `${nagan}, ${or.company}`;
          else if (!nagan.trim()) nagan = or.company;
          return {
            value: or,
            text: `${nagan}, ${or.address}, ${or.city}, ${or.state}`
          }
        });
        this.origin_addresses = response.data
        this.shipper_addresses = _.concat({
          value: '',
          text: 'Please Select an Origin Address'
        }, shipperAddr);

        let selected = _.find(response.data, addr => addr.is_default)

        if (this.employee_name) {
          const employee = this.user.employees.find(e => e.name === this.employee_name)
          if (employee && employee.origin_id) {
            selected = _.find(response.data, addr => addr.id === employee.origin_id)
          }
        }

        if (this.$refs.originDropDown) {
          const classList = this.$refs.originDropDown.classList;
          if (!selected) {
            this.selected = '';
            this.selectedOrigin = null;
            if (classList) {
              classList.add('is-invalid');
            }
          } else {
            this.hasDefaultOrigin = true;
            this.selected = selected;
            this.selectedOrigin = _.find(this.shipper_addresses, addr => addr.value == this.selected);
          }
        }
        // console.log('origin selected', this.selectedOrigin);
      }
    },
    // No classList
    // async newOriginSelected(val){
    //   try{
    //     const classList = this.$refs.originDropDown.classList;
    //     console.log(this.$refs);
    //     console.log('class list', classList);
    //     await this.$nextTick();
    //     if(this.selected === '' && !classList.contains('is-invalid')) {
    //       classList.add('is-invalid');
    //     }else{
    //       classList.remove('is-invalid');
    //     }
    //   } catch(e){
    //     console.error(e);
    //   }
    // },
    isRequired: async function (val) {
      if (val === null || !val.length) return false;
      return true;
    },
    gToLbs(pK) {
      var nearExact = pK / 1000 / 0.45359237;
      var lbs = Math.floor(nearExact);
      var oz = (nearExact - lbs) * 16;
      return {
        pounds: lbs,
        ounces: oz
      };
    },
    async findAcctID() {
      if (!this.acct_id) return

      // console.log("ACCT ID: ", this.acct_id)
      try {
        const { data: { id } } = await axios.get(`/addresses/${this.acct_id}`);
        if (id) {
          await this.onChangeRecipient(id)
        } else {
          throw new Error("Acct ID not found")
        }
      } catch (e) {
        this.$emit("alert", {
          message: "Address not found with the Account ID provided!",
          type: "danger"
        });
      }
    },
    async onChangeRecipient(id) {
      // console.log('recipient called', id);
      id = parseInt(id);
      let address = _.find(this.recipients, address => {
        return address.id === id;
      });
      if (address) {
        this.toAddress = address;
        this.acct_id = address.acct_id
      }
      this.onChanged();
      this.dw_set = false;
      if (this.checkWeight()) {
        this.getRate();
      }
    },
    onClearRecipient() {
      this.toAddress = {
        first_name: '',
        last_name: '',
        company: '',
        postal_code: '',
        city: '',
        address: '',
        country: "US",
        province: '',
        address2: '',
        phone: '',
        email: '',
      }
      this.order = {
        label_sticky: '',
        label_sticky_2: '',
      }
      this.acct_id = null;
      this.selectedHazmat = null;
    },
    async onChangeProduct(id) {
      let product = _.find(this.products, p => p.id === parseInt(id));
      this.tmpMyPkg = "0x0x0";
      if (product) {
        this.order_items = [];
        product.quantity = 1;
        this.selectedProduct = product;
        this.weight = this.getWeight(product.weight)
        this.package.length = parseFloat(product.package_length) || null
        this.package.width = parseFloat(product.package_width) || null
        this.package.height = parseFloat(product.package_height) || null
        this.declaredValue = parseFloat(product.declared_value) || null
        this.weight_set = true;
        // this.dw_set = true;
        if (this.country == 'US') {
          this.selectedService = product.service_class
          this.selectedPackage = product.package_type
          if (product.service_class == 'EM') {
            this.selectedConfirm = 'Sig'
          } else {
            this.selectedConfirm = 'DelCon'
          }
          await this.getRate();
        }
      }
    },
    onProductClear() {
      this.order_items = [];
      this.selectedProduct = null;
      this.selectedService = "";
      this.selectedPackage = "";
      this.declaredValue = null;
      this.tmpMyPkg = "0x0x0";
      this.weight = { lb: null, oz: null };
      this.package = { length: null, width: null, height: null };
      this.clearRates();
    },
    async onProductSave(data) {
      this.order_items = data.selectedProduct
      this.selectedProduct = data.selectedProduct;
      this.selectedService = data.selectedService;
      this.selectedPackage = data.selectedPackage;
      this.declaredValue = data.declaredValue;
      this.tmpMyPkg = data.tmpMyPkg;
      this.weight = data.weight;
      this.package = {
        length: data.dimensions.l,
        width: data.dimensions.w,
        height: data.dimensions.h,
      }
      if (this.selectedService !== 'FCM') {
        this.noLB = false;
      }
      await this.getRate();
    },
    verifyShipTo(e) {
      e.preventDefault();
      this.closeAlert();

      // this.$validator.validate("toAddress.*").then(() => {
      //   let address = {
      //     addressLines: [this.toAddress.address, "", ""],
      //     cityTown: this.toAddress.city,
      //     stateProvince: this.toAddress.province,
      //     postalCode: this.toAddress.postal_code,
      //     countryCode: this.toAddress.country
      //   };
      this.isLoading = true;
      axios
        .post("verify", { address: address })
        .then(response => {
          this.isLoading = false;
          // console.log(response.data);
          this.toAddress.address = response.data.addressLines[0];
          this.toAddress.city = response.data.cityTown;
          this.toAddress.province = response.data.stateProvince;
          this.toAddress.postal_code = response.data.postalCode;
          this.toAddress.country = response.data.countryCode;

          this.$emit("alert", {
            message: "Address is valid!",
            type: "success"
          });
        })
        .catch(error => {
          this.isLoading = false;
          this.$emit("alert", {
            message: "Invalid address.",
            type: "danger"
          });
          window.scrollTo(0, 0);
        });
      // });
    },
    verifyAddress() {
      let address = formatters.address.toPb(this.toAddress);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.toAddress = Object.assign({}, this.toAddress, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address could not be verified. Please double check address to avoid delay or undeliverable. You may still proceed to print label."
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },
    // suggestAddresses(e) {
    //   e.preventDefault();
    //   this.closeAlert();
    //   let address = formatters.address.toPb(this.toAddress);
    //   this.isLoading = true;
    //   this.suggestedAddresses = [];
    //   axios
    //     .post("/addresses/suggest", { address: address })
    //     .then(response => {
    //       this.isLoading = false;
    //       console.log("resp", response);

    //       let address = response.data.address;

    //       if (
    //         address &&
    //         (address.status === "VALIDATED_CHANGED" ||
    //           address.status === "VALIDATED_AND_NOT_CHANGED")
    //       ) {
    //         // Mass-assign to not delete name
    //         address = formatters.address.fromPb(address);
    //         this.toAddress = Object.assign({}, this.toAddress, address);
    //       }

    //       if (
    //         response.data.suggestions &&
    //         response.data.suggestions.address &&
    //         response.data.suggestions.address.length
    //       ) {
    //         this.suggestedAddresses = response.data.suggestions.address;
    //         this.$emit("alert", {
    //           message: this.$t("alerts.address.suggestions_found"),
    //           type: "success"
    //         });
    //       } else if (address) {
    //         address.status === "VALIDATED_CHANGED"
    //           ? this.$emit("alert", {
    //               message: this.$t("alerts.address.formatted_no_suggestions"),
    //               type: "success"
    //             })
    //           : this.$emit("alert", {
    //               message: this.$t("alerts.address.valid"),
    //               type: "success"
    //             });
    //       }
    //     })
    //     .catch(error => {
    //       this.isLoading = false;
    //       console.log("errrr", error);
    //       this.$emit("alert", {
    //         message:
    //           address.countryCode === "US"
    //             ? "Address could not be verified. Please double check address to avoid delay or undeliverable. You may still proceed to print label."
    //             : "Sorry, address verification is only for U.S. addresses",
    //         type: "danger"
    //       });
    //       window.scrollTo(0, 0);
    //     });
    // },
    // onChangeSuggestedAddress(value) {
    //   this.toAddress = Object.assign(
    //     {},
    //     this.toAddress,
    //     formatters.address.fromPb(value)
    //   );
    // },
    saveAddress(e) {
      e.preventDefault();
      this.isLoading = true;
      // console.log('save address toAddress: ', this.toAddress);
      axios
        .post("/addresses", Object.assign({}, this.toAddress, { acct_id: this.acct_id }))
        .then(resp => {
          this.$emit("alert", {
            message: resp.data.message || "Address saved!",
            type: "success"
          });
        })
        .catch(error => {
          this.$emit("alert", {
            message: formatters.errors.comma(error.response.data.errors),
            type: "danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onChangeSignatureOptions() {
      if (_.find(this.signatureOptions, { value: this.selectedConfirm })) {
        return;
      }
      if (
        this.signatureOptions.length === 1 &&
        this.signatureOptions[0].value === null
      ) {
        this.selectedConfirm = null;
      } else if (this.signatureOptions.length > 1) {
        const hasDelCon = _.find(this.signatureOptions, option => {
          return option.value === "DelCon";
        });
        if (hasDelCon) {
          this.selectedConfirm = "DelCon";
        } else if (!_.isNull(this.signatureOptions[0].value)) {
          this.selectedConfirm = this.signatureOptions[0].value;
        } else {
          this.selectedConfirm = this.signatureOptions[1].value;
        }
      } else if (
        this.selectedConfirm === null &&
        this.signatureOptions.length > 0
      ) {
        this.selectedConfirm = this.signatureOptions[0].value;
      } else if (this.signatureOptions.length === 0) {
        this.selectedConfirm = null;
      }
    },
    checkWeight() {
      const valid = this.weight.lb + this.weight.oz > 0;
      if (this.weight_set && !valid && !this.errors.has("weight")) {
        this.errors.add({
          field: "weight",
          msg: "You must specify a package weight"
        });
      }
      return valid;
    },
    clearRates() {
      this.rate_style = null;
      this.rate_msg = null;
      this.surcharge = 0;
      this.surcharge_msg = null;
      this.rates = {};
      this.service.alternateBaseCharge = 0;
      this.service.alternateTotalCharge = 0;
      this.service.baseCharge = 0;
      this.service.totalCarrierCharge = 0;
      this.insurance_price = 0;
      this.$set(
        this.service,
        "specialServices",
        _.map(this.service.specialServices, service => {
          return _.omit(service, "fee");
        })
      );
    },
    async onPackageChange() {
      this.clearRates();

      const { lb, oz } = this.weight;

      // if no weight, do nothing
      if (lb === null || oz === null) return;
      if (lb === 0 && oz === 0) return;

      if (this.dim_set || this.weight_set) {
        this.dw_set = true;
      }
      // await this.getRate()
    },
    async togglePostmark() {
      this.order.future_shipping_date = moment();
      await this.getRate();
    },
    async manualUpdateRate() {
      this.dw_set = false;
      await this.getRate();
    },
    async getRate() {
      // insurance validation
      if (this.user.enable_shipsurance && this.selectedInsurance !== 'shipsurance' && this.declaredValue) {
        this.selectedInsurance = 'shipsurance';
      }

      if (this.selectedInsurance == 'shipsurance' && this.declaredValue > 5000) {
        this.clearRates()
        this.$emit("alert", {
          message: 'Maximum insurance per package is $5,000. &nbsp;Please adjust accordingly.',
          type: "danger"
        });
        return
      }

      // validate first
      if (this.isFullNameRequired || !this.checkWeight() || !this.isAddressValid) {
        return;
      }

      if (this.isInternational) {
        if (!this.isWithCustoms || !this.declaredValue) {
          return;
        }
      }

      this.error_msg = null;

      this.closeAlert();
      this.clearRates();
      this.servicesList = {};
      let fromAddress = {
        addressLines: [this.selected.address, "", ""],
        cityTown: this.selected.city,
        stateProvince: this.selected.state,
        postalCode: this.selected.postal,
        countryCode: this.selected.country,
        phone: this.selected.phone,
        company: this.selected.company,
        name: this.selected.first_name + " " + this.selected.last_name
      };
      let toAddress = {
        addressLines: [this.toAddress.address, "", ""],
        cityTown: this.toAddress.city,
        stateProvince: this.toAddress.province,
        postalCode: this.toAddress.postal_code,
        countryCode: this.toAddress.country,
        phone: this.toAddress.phone
      };
      let parcel = {
        weight: {
          weight: parseInt(this.weight.lb) * 16 + parseInt(this.weight.oz),
          unitOfMeasurement: this.weight_measure
        },
        dimension: {
          length: this.package.length,
          width: this.package.width,
          height: this.package.height,
          unitOfMeasurement: "IN",
          // irregularParcelGirth: 1.0
        }
      };
      // Omit non fully-formed dimensions
      if (
        !(
          parcel.dimension.length &&
          parcel.dimension.width &&
          parcel.dimension.height
        )
      ) {
        parcel = _.omit(parcel, ["dimension"]);
        if (["SOFTPACK", "IRRPKG"].includes(this.selectedPackage)) {
          // don't proceed, we need dim
          return;
        }
      }

      let specialServices = [];

      if (this.toAddress.country === "US" && this.selectedConfirm) {
        specialServices.push({
          specialServiceId: this.selectedConfirm,
          inputParameters: []
        });
      }

      let extra = {
        insurance: null,
        declared_value: this.declaredValue,
        origin_id: this.selected.id
      };

      if (!_.isEmpty(this.selectedInsurance)) {
        extra.insurance = this.selectedInsurance;

        // shipsurance
        // if (this.selectedInsurance !== "parcel-protection") {
        //   let insuranceService = {
        //     specialServiceId: this.selectedInsurance.specialServiceId,
        //     inputParameters: []
        //   };

        //   Object.keys(this.selectedInsuranceInputs).forEach(key => {
        //     insuranceService.inputParameters.push({
        //       name: "INPUT_VALUE",
        //       value: this.selectedInsuranceInputs[key]
        //     });
        //   });

        //   specialServices.push(insuranceService);
        // }
      }
      let shipmentOptions = [];

      // console.log(this.order.future_shipping_date)
      // console.log(moment().toString())
      // console.log(moment().isBefore(this.order.future_shipping_date, "day") ? "yes" : "no")
      // if (!moment().isSame(this.order.future_shipping_date, "day")) {
      if (moment().isBefore(this.order.future_shipping_date, "day")) {
        shipmentOptions.push({
          name: "FUTURE_SHIPMENT_DATE",
          value: this.order.future_shipping_date
        });
      }

      if (this.order.label_sticky) {
        shipmentOptions.push({
          name: "PRINT_CUSTOM_MESSAGE_2",
          value: this.order.label_sticky
        });
      }

      if (this.order.label_sticky_2) {
        shipmentOptions.push({
          name: "PRINT_CUSTOM_MESSAGE_1",
          value: this.order.label_sticky_2
        });
      }

      let rates = [
        {
          carrier: "USPS",
          serviceId: this.selectedService.serviceId || this.selectedService,
          parcelType: this.selectedPackage,
          inductionPostalCode: this.selected.postal_origin || this.selected.postal,
          specialServices: specialServices
        }
      ];
      this.isLoading = true;
      try {
        const { data } = await axios.post("pb/rate", {
          fromAddress: fromAddress,
          toAddress: toAddress,
          parcel: parcel,
          rates: rates,
          shipmentOptions: shipmentOptions,
          extra
        });

        // this.shipper_addresses = response.data;
        this.rates = data.rates;
        if (data.length > 0) {
          this.rates = data.rates;
        }

        let servicesList = [];
        _.forEach(this.rates, value => {
          const service = _.find(this.services, {
            value: value.serviceId
          });
          if (service) {
            value.name = service.name;
            servicesList.push(value);
          }
          return value;
        });

        this.servicesList = servicesList;
        let rate = _.find(this.rates, rate => {
          return rate.serviceId === this.selectedService;
        });
        // console.log('the rate', rate);
        if (rate) {
          this.rate = rate;
          this.surcharge_msg = null;

          const dim1 = rate.specialServices.find(v => v.specialServiceId == 'NonStandardDim1')
          const dim2 = rate.specialServices.find(v => v.specialServiceId == 'NonStandardDim2')
          const vol = rate.specialServices.find(v => v.specialServiceId == 'NonStandardVol')

          if (vol) {
            this.surcharge += vol.fee;
            if (dim1 || dim2) {
              this.surcharge += dim1 ? dim1.fee : dim2.fee;
              this.surcharge_msg = 'Package length and volume exceeds standard'
            } else {
              this.surcharge_msg = 'Package volumn exceeds 2 cubic feet'
            }
          } else if (dim1) {
            this.surcharge += dim1.fee;
            this.surcharge_msg = 'Package length is between 23-30 inches'
          } else if (dim2) {
            this.surcharge += dim2.fee;
            this.surcharge_msg = 'Package length exceeds 30 inches'
          }

          const delivery_date = (rate.deliveryCommitment && rate.deliveryCommitment.estimatedDeliveryDateTime) ? moment(rate.deliveryCommitment.estimatedDeliveryDateTime) : null;
          let dDate = 'N/A';
          if (delivery_date && delivery_date.isValid()) {
            dDate = delivery_date.format('dddd, MMMM Do')
          } else {
            switch (this.selectedService) {
              case "EMI":
                dDate = "3 to 5 Business Days"
                break;
              case "PMI":
                dDate = "6 to 10 Business Days"
                break;
              case "FCPIS":
                dDate = "Varies by Destination"
                break;
              default:
                dDate = "N/A"
            }
          }
          this.deliveryEstimate = `${rate.destinationZone ? `Zone ${rate.destinationZone} - ` : ''}${dDate}`
          this.order.delivery_zone = rate.destinationZone ? rate.destinationZone : null
          this.$nextTick(() => {
            this.service = rate;
          });

          if (this.package.length && this.package.width && this.package.height) {
            const weight = parseInt(this.weight.lb * 16) + parseInt(this.weight.oz);
            let tier = parseFloat(this.package.length * this.package.width * this.package.height / 1728).toFixed(2);
            if (_.inRange(tier, 0, 0.11)) {
              tier = 0.1;
            }
            if (_.inRange(tier, 0.11, 0.21)) {
              tier = 0.2;
            }
            if (_.inRange(tier, 0.21, 0.31)) {
              tier = 0.3;
            }
            if (_.inRange(tier, 0.31, 0.41)) {
              tier = 0.4;
            }
            if (_.inRange(tier, 0.41, 0.51)) {
              tier = 0.5;
            }
            if (this.selectedService === "PRCLSEL") {
              if (_.inRange(tier, 0.51, 0.61)) {
                tier = 0.6;
              }
              if (_.inRange(tier, 0.61, 0.71)) {
                tier = 0.7;
              }
              if (_.inRange(tier, 0.71, 0.81)) {
                tier = 0.8;
              }
              if (_.inRange(tier, 0.81, 0.91)) {
                tier = 0.9;
              }
              if (_.inRange(tier, 0.91, 1.01)) {
                tier = 1.0;
              }
            }
            console.log("TIER: ", tier);

            if (weight <= 320 && this.package.length < 18 && this.package.width < 18 && this.package.height < 18) {
              if (cubicWeight.isCubicWeight(tier, rate.destinationZone, (rate.alternateBaseCharge || rate.baseCharge), this.selectedService)) {
                this.rate_style = 'rate-success';
                this.rate_msg = `Cubic Rate ${tier.toFixed(1)} Activated`;
              }
            }
            if (rate.dimensionalWeight.weight) {
              this.rate_style = 'rate-danger';
              this.rate_msg = `DIM Weight Price Activated - ${this.package.length} x ${this.package.width} x ${this.package.height} in`;
            }
          }
        }
        this.updateOrder();
        this.isLoading = false;
      } catch (e) {
        if (!e.response) {
          let msg = "Invalid entry, please make sure all information provided are valid."
          this.error_msg = msg;
          // this.$emit("alert", {
          //   message: msg,
          //   type: "danger"
          // });
        } else {
          const { data: { errors } } = e.response;
          const key = Object.keys(errors).pop();
          let msg = "Invalid entry, please make sure all information provided are valid.";
          if (key && !!errors[key]) {
            msg = errors[key];
          }
          this.error_msg = msg;
          // this.$emit("alert", {
          //   message: msg,
          //   type: "danger"
          // });
        }
      } finally {
        this.refreshUserBalance();
        this.isLoading = false;
      }
    },
    async updateOrder() {
      if (!this.order.id || !this.canUpdateOrder) {
        return;
      }

      if (this.order.status === 3) {
        this.$toastr.e("Can't update rate for shipped order");
        return;
      }

      this.order.shipping_address = { ...this.toAddress };
      this.order.origin_id = this.selected.id;

      const service = this.getShippingService(this.selectedService);
      this.order.shipping_service_id = service.id;
      this.order.total_weight =
        parseFloat(this.weight.lb) * 16 + parseFloat(this.weight.oz);
      this.order.package_width = this.package.width;
      this.order.package_height = this.package.height;
      this.order.package_length = this.package.length;
      this.order.special_services = this.rate.specialServices;
      this.order.package_type = this.selectedPackage;
      this.order.confirmation = this.selectedConfirm;
      this.order.insurance = this.selectedInsurance;
      this.order.declared_value = this.declaredValue;
      this.order.customs_items = this.customs.items;
      this.order.customs_signature = this.customs.sender_signature;
      this.order.customs_content_type = this.customs.content_type;

      let data = { ...this.order };

      try {
        const response = await axios.patch("/orders/" + this.order.id, data);
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });

        if (response.data.order) {
          this.order = response.data.order;
          await this.syncFromOrder(this.order);
          this.$emit("updateOrder", this.order);
        }
        if (response.data.rules) {
          this.rules = response.data.rules;
        }
      } catch (error) {
        this.$emit("alert", {
          message: Object.values(error.response.data.errors).join(", "),
          type: "danger"
        });
      }

      //this.refresh();
      this.isLoading = false;
    },
    /**
     * Fills form data from order object
     */
    async syncFromOrder(order) {
      if (!order.id) {
        return;
      }
      console.log("Order: ", order);
      // console.log("copy: ", order);
      this.selected = this.origin_addresses.find(o => o.id === order.origin_id) || this.origin_addresses.find(o => o.is_default);
      this.selectedOrigin = _.find(this.shipper_addresses, addr => addr.value == this.selected)
      // console.log("origin", this.selected);
      // console.log("origin_addresses", this.origin_addresses);
      // console.log("shipper addresses", this.shipper_addresses);
      this.toAddress = order.shipping_address;
      //this.country = this.order.shipping_address.country;
      this.description = order.description;
      this.order.label_sticky = order.label_sticky
      this.order.label_sticky_2 = order.label_sticky_2

      // this.$nextTick((order) => {
      // console.log("serv", this.serviceOptions)
      // console.log("serv", order.shipping_service.code)
      // console.log("pkg type", order.package_type)
      const serviceOption = _.find(this.serviceOptions, option => {
        return order.shipping_service.code === option.value;
      });
      if (serviceOption) {
        this.selectedService = serviceOption.value;
        this.service = this.serviceRules;
        console.log("Service: ", this.serviceRules);
      }
      this.service.special_services = order.special_services;
      this.selectedPackage = order.package_type;
      this.selectedConfirm = order.confirmation;
      this.declaredValue = order.declared_value;
      this.selectedInsurance = order.insurance;
      this.weight = this.getWeight(order.total_weight);
      this.package = {
        width: order.package_width,
        height: order.package_height,
        length: order.package_length
      };
      const marketplace = this.marketplaceOptions.find(v => v.value == order.marketplace_id)
      if (marketplace) {
        this.setMarketplace(marketplace)
      }

    // add custom forms
      this.customs.sender_signature = order.customs_sender_signature ? order.customs_sender_signature : this.user.name;
      this.customs.content_type = order.customs_content_type || 'MERCHANDISE';
      if (order.customs_items) {
        this.lines = [];
        order.customs_items.forEach(i => {
          this.lines.push({
            quantity: i.quantity,
            description: i.description,
            value: i.unitPrice,
            weight1: this.getWeight(i.unitWeight.weight).lb || null,
            weight2: this.getWeight(i.unitWeight.weight).oz || null,
            origin: 'US',
          });
        });
      }
      // });
    },
    async printLabel(type = "", notify = true) {
      this.closeAlert();
      const isTestPrint = type === "test" ? true : false;

      if (this.isFullNameRequired) {
        this.$emit('alert', {
          type: 'danger',
          message: 'Last name is required on printing international labels.'
        })
        return;
      }

      if (this.selectedInsurance && this.insurance_price > this.shipsurance) {
        this.$emit('alert', {
          type: 'danger',
          message: 'Not enough Shipsurance Balance.'
        })
        return;
      }

      if (!this.checkWeight() || !this.isAddressValid || !(this.rate.alternateBaseCharge || this.rate.baseCharge)) {
        return;
      }

      if (type === "return" && notify) {
        try {
          const body = "The Ship To and From address will be inverted. &nbsp;Your account will be charged once the label is used. &nbsp;You can manage the label on the SB Return Labels page.";
          const title = `Scan-Based Return Label`
          if (!Cookies.get(hash(body))) {
            let dialog = await this.$dialog.confirm({ title, body }, {
              remember: true,
              view: 'print',
              customClass: 'print-dialog',
              proceed: 'Print'
            });
            dialog.close();
          }
        } catch (e) {
          return;
        }
      }

      if (type === "rlabel" && notify) {
        try {
          const body = "The Ship To and From address will be inverted. &nbsp;Your account will be charged as soon you print the label.";
          const title = 'Prepaid Return Label'
          if (!Cookies.get(hash(body))) {
            let dialog = await this.$dialog.confirm({ title, body }, {
              remember: true,
              view: 'print',
              customClass: 'print-dialog',
              proceed: 'Print'
            });
            dialog.close();
          }
        } catch (e) {
          return;
        }
      }

      if (type === "both") {
        try {
          const body = "Two labels will be generated. &nbsp;Only the outbound label will be charged. &nbsp;The Scan-Based Return label will be charged once the label is used.";
          const title = "Label + Scan-Based Return"
          if (notify && !Cookies.get(hash(body))) {
            let dialog = await this.$dialog.confirm({ title, body }, {
              remember: true,
              view: 'print',
              customClass: 'print-dialog',
              proceed: 'Print'
            });
            dialog.close();
          }
          this.printLabel("", false);
          this.printLabel("both-return", false);
          return;
        } catch (e) {
          return;
        }
      }

      if (type === "rboth") {
        try {
          const body = "Two labels will be charged and generated, an outbound and a return label.";
          const title = 'Label + Prepaid Return';
          if (notify && !Cookies.get(hash(body))) {
            let dialog = await this.$dialog.confirm({ title, body }, {
              remember: true,
              view: 'print',
              customClass: 'print-dialog',
              proceed: 'Print'
            });
            dialog.close();
          }

          this.printLabel("", false);
          this.printLabel("rlabel-both", false);
          return;
        } catch (e) {
          return;
        }
      }

      const isReturn = ["return", "rlabel", "rlabel-both", "both-return"].indexOf(type) > -1;

      // this.$v.$touch();

      // if (this.$v.$invalid) {
      //   return;
      // }

      // this.$validator.validateAll().then(async result => {
      //   if (!result) {
      //     return;
      //   }
      this.status = "shipping";

      /**
        There's already an EXISTING ORDER
        Question: Is there a change for this to be called inder new shipment?
      if (this.order.id) {
        await this.updateOrder();

        let url = "printlabel/" + this.order.id;
        if (type === "return") {
          url += "/return";
        }
        // Return Label
        axios
          .post(url, {
            extra: {
              tracking_price: this.tracking_price,
              insurance_price: this.insurance_price,
              employee_name: this.employee_name,
              future_shipping: this.future_shipping,
              future_shipping_date: this.future_shipping_date,
              marketplace: this.selectedMarketplace,
            }
          })
          .then(async(response) => {
            // this.shipper_addresses = response.data;
            this.isLoading = false;

            // Set customs name
            if (
              // this.order.shipping_address.country !== "US" &&
              this.isInternational &&
              this.setCustomsSignature
            ) {
              this.setCustomsName(this.customs.sender_signature);
            }

            // Add to printer
            let decoded = response.data;
            decoded.type = type;

            //const decoded = atob(response.data.label)
            this.addPrintJob(decoded);
            this.printed = true;
            this.status = "shipped";

            this.order = response.data.order;
            this.syncFromOrder(this.order);

            setTimeout(() => {
              this.$emit("updateOrder", this.order);
              this.status = "waiting";
            }, 4500);
            //window.open(response.data.label);
          })
          .catch(error => {
            this.isLoading = false;
            this.status = "waiting";
            let message = error.response.data.message;
            if (error.response.data.errors) {
              message += ": ";
              message += Object.values(error.response.data.errors).join(" ");
            }
            this.$emit("alert", {
              message: message,
              type: "danger"
            });
          })
          .finally(() => {
            //this.fetchOrders();
          });

        return;
      } // end of EXISTING ORDER
      **/

      let fromAddress = {
        addressLines: [this.selected.address, "", ""],
        cityTown: this.selected.city,
        stateProvince: this.selected.state,
        postalCode: this.selected.postal,
        countryCode: this.selected.country,
        phone: this.selected.phone
      };

      if (this.selected.company) {
        fromAddress.company = this.selected.company || '';
      }
      if (this.selected.first_name || this.selected.last_name) {
        fromAddress.name = (this.selected.first_name || '') + " " + (this.selected.last_name || '');
      }

      let toAddress = {
        addressLines: [this.toAddress.address, this.toAddress.address2, ""],
        cityTown: this.toAddress.city,
        stateProvince: this.toAddress.province,
        postalCode: this.toAddress.postal_code,
        countryCode: this.toAddress.country,
        email: this.toAddress.email,
        phone: this.toAddress.phone
      };

      if (this.toAddress.company) {
        toAddress.company = this.toAddress.company;
      }
      if (this.toAddress.first_name || this.toAddress.last_name) {
        toAddress.name = (this.toAddress.first_name || '').trim() + " " + (this.toAddress.last_name || '').trim();
      }

      let parcel = {
        weight: {
          weight: parseInt(this.weight.lb) * 16 + parseInt(this.weight.oz),
          unitOfMeasurement: this.weight_measure
        },
        dimension: {
          length: parseInt(this.package.length),
          width: parseInt(this.package.width),
          height: parseInt(this.package.height),
          unitOfMeasurement: "IN",
          // irregularParcelGirth: 1.0
        },
        valueOfGoods: _.isEmpty(this.selectedInsurance)
          ? null
          : parseFloat(this.declaredValue),
        currencyCode: "USD"
      };
      // Omit non fully-formed dimensions
      if (
        !(this.package.length && this.package.width && this.package.height)
      ) {
        parcel = _.omit(parcel, ["dimension"]);
        this.package.length = null;
        this.package.width = null;
        this.package.height = null;
      }
      let rates = [
        {
          carrier: "USPS",
          parcelType: this.selectedPackage,
          serviceId: this.selectedService,
          specialServices: [],
          inductionPostalCode: this.selected.postal_origin || this.selected.postal
        }
      ];

      if (this.selectedHazmat !== null) {
        rates[0].specialServices.push({
          specialServiceId: "hazmat",
          inputParameters: [
            {
              name: "HAZMAT_TYPE",
              value: this.selectedHazmat
            }
          ]
        });
      }

      // for return labels, update inductionPostalCode to the reciepient postal code
      if (isReturn) {
        rates[0].inductionPostalCode = this.toAddress.postal_code;
      }

      if (
        this.toAddress.country === "US" &&
        (type !== "return" && type !== "both-return") &&
        this.selectedConfirm
      ) {
        // console.log('adde special services', this.selectedConfirm)
        rates[0].specialServices.push({
          specialServiceId: this.selectedConfirm,
          inputParameters: []
          /*inputParameters: [
              {
                name: 'INPUT_VALUE',
                value: '50'
              }
            ]*/
        });
      }

      // shipsurance
      // if (
      //   !_.isEmpty(this.selectedInsurance) &&
      //   this.selectedInsurance !== "parcel-protection"
      // ) {
      //   let insuranceService = {
      //     specialServiceId: this.selectedInsurance.specialServiceId,
      //     inputParameters: []
      //   };

      //   Object.keys(this.selectedInsuranceInputs).forEach(key => {
      //     insuranceService.inputParameters.push({
      //       name: "INPUT_VALUE",
      //       value: this.selectedInsuranceInputs[key]
      //     });
      //   });
      //   console.log('add special services', insuranceService)
      //   rates[0].specialServices.push(insuranceService);
      // }

      let documents = [
        {
          type: "SHIPPING_LABEL",
          size: "DOC_4X6",
          // PDF
          fileFormat: "PDF",
          contentType: "URL",
          printDialogOption: "EMBED_PRINT_DIALOG",
          // PNG
          // fileFormat: "PNG",
          // contentType: "BASE64",
        }
      ];

      let shipmentOptions = [];

      // if (!moment().isSame(this.order.future_shipping_date, "day")) {
      if (moment().isBefore(this.order.future_shipping_date, "day")) {
        this.order.future_shipping = true;
        shipmentOptions.push({
          name: "FUTURE_SHIPMENT_DATE",
          value: this.order.future_shipping_date
        });
      } else {
        this.order.future_shipping = null;
        this.order.future_shipping_date = null;
      }


      if (this.order.label_sticky) {
        shipmentOptions.push({
          name: "PRINT_CUSTOM_MESSAGE_2",
          value: this.order.label_sticky
        });
      }

      if (this.order.label_sticky_2) {
        shipmentOptions.push({
          name: "PRINT_CUSTOM_MESSAGE_1",
          value: this.order.label_sticky_2
        });
      } else if (type === "return" || type === "both-return") { // SBR
        shipmentOptions.push({
          name: "PRINT_CUSTOM_MESSAGE_1",
          value: moment.tz(this.selected.timezone || "America/New_York").format('ddd MMM DD YYYY')
        });
      }

      this.isLoading = true;

      let printData = {
        fromAddress: fromAddress,
        toAddress: toAddress,
        parcel: parcel,
        rates: rates,
        documents: documents,
        extra: {
          ref_id: this.order.ref_id,
          order_number: this.order.order_number,
          description: this.description,
          confirmation: this.selectedConfirm,
          insurance: this.insuranceId,
          declared_value: this.declaredValue,
          origin_id: this.selected.id,
          label_sticky: this.order.label_sticky,
          label_sticky_2: this.order.label_sticky_2,
          tracking_price: this.tracking_price,
          insurance_price: this.insurance_price,
          employee_name: this.employee_name,
          order_items: this.order_items.length ? this.order_items : this.selectedProduct ? [this.selectedProduct] : [],
          delivery_zone: this.order.delivery_zone,
          acct_id: this.acct_id,
          future_shipping: this.order.future_shipping,
          future_shipping_date: this.order.future_shipping ? this.order.future_shipping_date : null,
          marketplace: this.selectedMarketplace,
          hazmat: this.selectedHazmat
        },
        isTestPrint,
      };

      if (this.isInternational) {
        // if (this.toAddress.country !== "US") {
        // if (!(await this.$refs.customsModal.isValid())) {
        //   this.$toastr.e("Please enter the Content Description");
        //   this.$refs.customsModal.show();
        //   return;
        // }

        const customsItems = this.customs.items.map(i => {
          const { tariff, quantity, unitPrice, unitWeight: { weight } } = i;
          // console.log("Weight", weight);
          return Object.assign({}, i, {
            unitPrice: unitPrice / quantity,
            unitWeight: {
              weight: weight / quantity,
              unitOfMeasurement: "OZ",
            },
            hSTariffCode: tariff,
          });
        });

        // console.log("customs items", customsItems);

        shipmentOptions.push({
          name: "SHIPPING_LABEL_SENDER_SIGNATURE",
          value: this.customs.sender_signature
        });
        printData.customs = {
          customsInfo: {
            reasonForExport: this.customs.content_type,
            currencyCode: "USD"
          },
          customsItems
        };
      }

      printData.shipmentOptions = shipmentOptions;

      let url = "printlabel";
      // SBR
      if (type === "return" || type === "both-return") {
        url += "/return";
        printData.shipmentType = "RETURN";
        printData.fromAddress = toAddress;
        printData.toAddress = fromAddress;
      }
      // PREPAID
      if (type === "rlabel" || type === "rlabel-both") {
        printData.extra.prepaid_return = true;
        // if (type === "rlabel-both") type = "pdf";
      }
      // console.log("printdata: ", JSON.stringify(printData));
      axios
        .post(url, printData)
        .then(response => {
          // this.shipper_addresses = response.data;
          this.isLoading = false;

          const decoded = response.data;
          decoded.type = type;

          if (isTestPrint) {
            decoded.type = "";
          }
          this.addPrintJob(decoded);
          this.status = "shipped";

          // stop from clearing the form if testprint
          if (isTestPrint) {
            setTimeout(() => {
              this.status = "waiting";
            }, 4500);
            return;
          }

          // Set customs name
          if (printData.customs && this.setCustomsSignature) {
            this.setCustomsName(this.customs.sender_signature);
          }

          //this.order.label_print = response.data.documents[0].contents;
          //this.saveOrder(true);
          //window.open(response.data.documents[0].contents);

          console.log("set dirty to false")
          setTimeout(() => {
            // Reset data to initial
            if (this.autoClearFields === "yes") {
              this.onClickClearAll();
              this.status = "waiting";
              console.log("onclickclearall called");
            }
          }, 5000);

        })
        .catch(error => {
          this.isLoading = false;
          this.status = "waiting";
          this.$emit("alert", {
            message: formatters.errors.fromResponse(error),
            type: "danger"
          });
          // alert(JSON.parse(error.response.data.message)[0].additionalInfo);
        })
        .finally(() => {
          if (!isTestPrint) {
            this.refreshUserBalance();
            this.refreshUser();
            this.refreshShipsurance();
          }
        });
      // });
    },
    onClickClearAll() {
      this.acct_id = null;
      this.rate_style = null;
      this.rate_msg = null;
      this.error_msg = null
      this.status = "waiting"
      this.showCustomsModal = false
      this.validCustomForm = false
      this.isValueChanged = false
      this.isWeightChanged = false
      this.err_msg = ""
      // this.customs = {
      //   content_type: null,
      //   sender_signature: "",
      //   items: []
      // }
      this.lines = [{
        origin: "US",
      }]
      this.setCustomsSignature = false
      this.deliveryEstimate = ''
      this.selectedConfirm = "DelCon"
      this.isLoading = false
      this.canUpdateOrder = false
      this.getRateTimer = null
      this.rate = {}
      this.tracking_price = 0
      this.insurance_price = 0
      this.description = ""
      this.servicesList = {}
      this.weight_set = false
      this.dim_set = false
      this.dw_set = false
      this.noLB = false
      this.weight_measure = "OZ"
      this.$refs.recipientSelect.onClearItems();
      this.$refs.productSelect.onClearItems();
      this.selectedMarketplace = 4
      this.marketplaceText = 'Marketplace Reference'
      this.onProductClear();
      this.onClearRecipient();
      this.dirty = false;
      // this.$router.replace({
      //   path: "/orders/ready-to-ship"
      // });
      // this.$nextTick(() => {
      //   this.$router.replace({
      //     path: "/orders/new-shipment",
      //     query: { reset: true }
      //   });
      // });
    },
    fetchAddress(id) {
      axios
        .get("shipping-addresses/" + id)
        .then(response => {
          // this.shipper_addresses = response.data;
          this.toAddress = response.data;
        })
        .catch(error => { });
    },
    closeAlert() {
      this.$emit("alert_close");
    },
    async getCityState(zip, ship) {
      if (this.country == 'US') {
        this.isLoading = true;
        // console.log('isloading', this.isLoading ? 'true' : 'false');
        let url = "https://zip.getziptastic.com/v2/US/" + zip;
        // axios.defaults.crossDomain = true;
        var axiosCrossDomain = axios;
        delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
        delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];
        try {
          const { data } = await axiosCrossDomain(url, { method: "GET" });
          const pattern = /^(APO|FPO|DPO)\s(AE|AA|AP)$/
          let { state_short, city, country } = data;

          if (pattern.test(city ? city.toUpperCase() : '')) {
            const [c, s] = city.split(" ");
            state_short = s;
            city = c;
          }

          if (ship == "shipto") {
            //this.toAddress.address2 = response.data.county;
            this.toAddress.city = city;
            this.toAddress.province = state_short;
            this.toAddress.country = country;
            // this.toAddress.postal_code = response.data.postalCode;
            // console.log(response.data);
          } else {
            this.selected.city = city;
            this.selected.state = state_short;
            this.selected.country = country;
            // console.log(response.data);
            // this.selected.postal = response.data.postalCode;
          }
          // console.log('city state toAddress: ', this.toAddress);
          // console.log('getcityzip on change is now next');
          await this.onChanged();
        } catch (error) {
          console.log('City State Error: ', error);
        }
        this.isLoading = false;
      }
    },
    async setWeight() {
      // console.log(this.weight.oz, this.weight.lb);
      if ([0, NaN].includes(parseInt(this.weight.oz)) && [0, NaN].includes(parseInt(this.weight.lb))) {
        return;
      } else if ([0, NaN].includes(parseInt(this.weight.oz)) && ![0, NaN].includes(parseInt(this.weight.lb))) {
        this.weight.oz = 0;
      }

      if (this.weight.oz % 16) {
        if (!this.noLB) {
          this.weight.lb =
            Number(~~(this.weight.oz / 16)) + Number(this.weight.lb);
          this.weight.oz = Number(this.weight.oz % 16);
        } else {
          this.weight.lb = 0;
          this.weight.oz = Number(this.weight.oz % 16);
        }
      }

      if (this.selectedService === "FCPIS") {
        const total_weight = (this.weight.lb * 16) + this.weight.oz;
        if (total_weight > 64) {
          let msg = "Maximum weight limit for First-Class Package International is 4lbs.";
          this.error_msg = msg;
          this.weight = Object.assign({}, { lb: 0, oz: 0 });
          return;
        }
      }

      if (!this.weight_set) {
        await this.getRate();
      }

      if (this.weight_set) {
        // console.log("set dw_set to true via weight change")
        this.dw_set = true;
      }
      // console.log("dw_set value via weight", this.dw_set);

      this.weight_set = true;
    },
    onChangeDeclaredValue(val) {
      if (val && this.user.enable_shipsurance) {
        this.selectedInsurance = 'shipsurance';
      }

      this.getRate();
    },
    onChangeInsurance(val) {
      // this.validate();

      /*
      this.selectedInsuranceInputs = {};

      if (_.isEmpty(val.specialServiceId)) {
        this.selectedInsurance = {};

        setTimeout(() => {
          this.getRate();
        }, 100);
      }*/
    },
    async onChangeDimensions() {
      this.clearRates();

      // console.log('onDimension changed called');
      const status = this.checkDimensions;
      if (status !== false && (this.weight.lb || this.weight.oz)) {
        await this.$nextTick();
        if (!this.dim_set) {
          await this.getRate();
        }
        if (this.dim_set) {
          // console.log("set dw_set to true via weight change")
          this.dw_set = true;
        }
        // console.log("dw_set value via dimension", this.dw_set);
        this.dim_set = true;
      }
    },
    onKeyUpDeclaredValue(e, rule) {
      clearTimeout(this.getRateTimer);
      let val = e.target.value;
      this.declaredValue = val;
      if (!val) {
        this.selectedInsurance = null;
        this.selectedInsuranceInputs[rule.brandedName] = 0;
        this.getRate();
      } else if (rule && val >= rule.minValue && val <= rule.maxValue) {
        this.getRateTimer = setTimeout(() => {
          this.getRate();
        }, 250);
      }
    },
    // customs methods
    onShowCustomsModal() {
      // this.$ref.customsModal.show()
      this.showCustomsModal = true;
    },
    async onHideCustomsModal() {
      // this.$ref.customsModal.hide()
      this.showCustomsModal = false;
      // this.updateCustomForm();
      await this.getRate();
    },
    updateCustomForm() {
      this.customs.items = this.lines.map(line => {
        if (line.quantity && line.description) {
          const lb = line.weight1 ? parseInt(line.weight1) * 16 : 0;
          const oz = line.weight2 ? parseInt(line.weight2) : 0;
          return {
            quantity: parseInt(line.quantity),
            description: line.description,
            unitPrice: parseFloat(line.value),
            tariff: line.tariff,
            unitWeight: {
              weight: lb + oz,
              unitOfMeasurement: "OZ",
            },
            originCountryCode: line.origin
          }
        }
      });

      let total_price = 0, total_weight = 0, declaredWeight = parseFloat(this.weight.lb) * 16 + parseFloat(this.weight.oz);
      this.customs.items.forEach(function loop(obj) {
        if (loop.stop || typeof (obj) == "undefined") return;
        total_price += obj.unitPrice;
        total_weight += obj.unitWeight.weight;
        if (!parseFloat(obj.unitWeight.weight)) {
          total_weight = 0; loop.stop = true;
        } else if (!parseFloat(obj.unitPrice)) {
          total_price = 0; loop.stop = true;
        }
      })
      //TODO: Make validCustomForm computed
      this.validCustomForm = true;
      if (parseFloat(this.declaredValue) != parseFloat(total_price) || parseFloat(total_weight) > parseFloat(declaredWeight)) {
        this.validCustomForm = false;
      }
    },
    addLine() {
      this.lines.push({
        origin: "US",
      });
    },
    deleteLastLine() {
      if (this.lines.length > 1) {
        this.lines = this.lines.splice(0, this.lines.length - 1);
      }
    },
    onGoogleAddressChange(addr) {
      this.toAddress = Object.assign({}, this.toAddress, addr);
      this.onChanged();
    },
    onCustomValueChange() {
      this.isValueChanged = true;
    },
    onCustomWeightChange() {
      this.isWeightChanged = true;
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      const keyCodes = [45, 109, 189];
      let order_number = this.order.order_number;
      if (!order_number && keyCodes.includes(charCode)) {
        evt.preventDefault();
      } else if (order_number && order_number.slice(-1) === '-' && keyCodes.includes(charCode)) {
        evt.preventDefault();
      } else if (!keyCodes.includes(charCode) && (charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showAddressModal() {
      this.$refs.addressModal.show();
    },
    onAddressSave(data) {
      this.toAddress = data
      this.onChanged();
      this.dw_set = false;
      if (this.checkWeight()) {
        this.getRate();
      }
    },
    async changedOrigin(val) {
      if (val.value) {
        const old_val = this.selected.value;
        this.selected = val.value;
        if (old_val !== val.value && this.checkWeight() && this.isAddressValid) {
          this.getRate();
        }
        if (!this.hasDefaultOrigin) {
          this.onTouched(true);
          this.hasDefaultOrigin = true;
        }
      } else {
        this.clearRates();
      }
    },
    getMarketplaceWidth(code) {
      const m = {
        grandshipper: 20,
        amazon: 19,
        'big commerce': 22,
        'ecwid by lightspeed': 19,
        'facebook marketplace': 22,
        grailed: 21,
        instagram: 21,
        mercari: 18,
        opencart: 20,
        paypal: 18,
        'quickbooks by intuit': 21,
        square: 18,
        squarespace: 19,
        stripe: 20,
        walmart: 19,
        whatnot: 21,
        wix: 22,
        woocommerce: 22,
        'x-cart': 20,
      }
      return m[code]
    },
    async getMarketplace() {
      const { data } = await axios.get("/marketplaces?ajax=true")

      const toInclude = ["amazon", "big commerce", "ecwid by lightspeed", "facebook marketplace", "grailed",
        "instagram", "mercari", "opencart", "paypal", "quickbooks by intuit",
        "square", "squarespace", "stripe", "walmart", "whatnot", "wix", "woocommerce", "x-cart"]

      this.marketplaces = data.map(m => {
        if (toInclude.includes(m.code)) {
          return { text: m.name, value: m.id, }
        }
        return null
      }).filter(v => v)

      const selectedMarketplaces = this.user.marketplaces ? this.user.marketplaces.map(u => u.value) : null
      const currentDefault = this.user.marketplaces ? this.user.marketplaces.find(u => u.is_default) : null
      let marketplaceOptions = []

      const svg_logos = [
        'amazon', 'big commerce', 'ebay', 'etsy', 'facebook marketplace', 'instagram',
        'paypal', 'shopify', 'walmart', 'square', 'squarespace', 'wix', 'x-cart'
      ]

      if (selectedMarketplaces) {
        marketplaceOptions = data.map(m => {
          if (selectedMarketplaces.includes(m.id)) {
            return {
              value: m.id,
              text: m.name,
              img: svg_logos.includes(m.code)
                ? `/images/integrations/${m.code}/logo.svg`
                : `/images/integrations/${m.code}/table-icon.png`,
              code: m.code,
              is_default: currentDefault && currentDefault.value == m.id ? 1 : 0,
              width: this.getMarketplaceWidth(m.code),
            }
          }
          return null
        }).filter(m => m)
      }
      let defaultMarketplace = {
        value: 4,
        text: 'Grandshipper',
        img: '/images/integrations/grandshipper/table-icon.png',
        code: 'grandshipper',
        is_default: currentDefault ? 0 : 1,
        width: 20,
      }
      this.marketplaceOptions = [
        defaultMarketplace,
        ..._.orderBy(marketplaceOptions, 'text')
      ]
    },
    async setMarketplace(data) {
      this.marketplaceText = data.text
      if (data.value) {
        this.selectedMarketplace = data.value
      } else {
        this.selectedMarketplace = 4
      }
      this.$refs.marketplaceDropdown.hide()
    },
    async setSelectedShippingOptions() {
      this.shippingSelectOptions = shippingOptions.map(v => {
        if (this.selectedShippingOptions.includes(v.value)) {
          // lets just return the setup for now
          if (v.value === 'LBL') return { value: 'label', text: v.text }
          if (v.value === 'SBR') return { value: 'return', text: v.text }
          if (v.value === 'LBLSBR') return { value: 'both', text: v.text }
          if (v.value === 'LBLPDF') return { value: 'pdf', text: v.text }
          if (v.value === 'TSTLBL') return { value: 'test', text: v.text }
          if (v.value === 'RLBL') return { value: 'rlabel', text: v.text }
          if (v.value === 'LBLRLBL') return { value: 'rboth', text: v.text }
          return v
        }
        return null;
      }).filter(v => v !== null);
      console.log("new shipment - shipping select option: ", this.shippingSelectOptions)
    },
    async setDefaultMarketplace(val) {
      this.isLoading = true
      try {
        const mp = this.user.marketplaces.map(m => {
          if (val == m.value) {
            const marketplace = this.marketplaces.find(v => v.value == val)
            this.selectedMarketplace = marketplace.id
            this.marketplaceText = marketplace.text
            return { value: m.value, is_default: 1 }
          }
          return { value: m.value }
        })

        if (!val) {
          this.selectedMarketplace = 4
          this.marketplaceText = 'Marketplace Reference'
        }

        const response = await axios.post("/users/marketplaces", { marketplaces: mp });
        // console.log('response', response);
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
      } catch (e) {
        this.$emit("alert", {
          message: e.response.data.message,
          type: "danger"
        });
      } finally {
        await this.refreshUser()
        await this.getMarketplace()
        this.isLoading = false
        this.$refs.marketplaceDropdown.hide()
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/NewShipment.vue